// // // import React, { useEffect, useRef, useState } from "react";
// // // import { useDispatch, useSelector } from "react-redux";
// // // import { useLocation } from "react-router-dom";

// // // import {
// // //   getPostFinalizedData,
// // //   getStudentDetails,
// // // } from "../../services/admin.services";
// // // import docxImageUrl from "../../assets/docx.png";
// // // import pdfImageUrl from "../../assets/pdf.jpg";
// // // import {
// // //   IconPhoto,
// // //   IconSend,
// // //   IconPaperclip,
// // //   IconReload,
// // // } from "@tabler/icons-react";
// // // import {
// // //   setSocketDetails,
// // //   setUserDetails,
// // // } from "../../state/reducers/userSlice";

// // // const Comments = ({ activeTab }) => {
// // //   const location = useLocation();
// // //   const studentDetails = useSelector((state) => state.user.userDetails);
// // //   const [comment, setComment] = useState("");
// // //   const [comments, setComments] = useState({}); // Store comments by room
// // //   const [processedMessageIds, setProcessedMessageIds] = useState(new Set()); // Track message IDs
// // //   const [currentRoom, setCurrentRoom] = useState(""); // Track the current room
// // //   const [socket, setSocket] = useState(null);
// // //   const [assignedAdmins, setAssignedAdmins] = useState([]);
// // //   const [file, setFile] = useState(null); // Store the selected file
// // //   const user_id = useSelector((state) => state.user.user_id); // Logged-in user's ID
// // //   const username = useSelector((state) => state.user.username || ""); // Logged-in user's username
// // //   const first_name = useSelector((state) => state.user.first_name || "");
// // //   const last_name = useSelector((state) => state.user.last_name || "");
// // //   const [mentionPosition, setMentionPosition] = useState(null); // Track @ position
// // //   const [mentionSuggestions, setMentionSuggestions] = useState([]); // Store university suggestions
// // //   const [loading, SetLoading] = useState(false);
// // //   const [isLoading, setIsLoading] = useState(false); // Loader state
// // //   const [profilePicCache, setProfilePicCache] = useState({}); // Cache for profile pictures
// // //   const dispatch = useDispatch();
// // //   const fileInputRef = useRef(null);
// // //   const messagesContainerRef = useRef(null);
// // //   const userProfile = useSelector((state) => state.user.profile || {}); // Normalize file paths (convert backslashes to forward slashes and handle url prefixing)
// // //   const normalizeFilePath = (path) => {
// // //     if (!path) return null;

// // //     // Replace backslashes with forward slashes (including encoded ones)
// // //     let normalizedPath = path.replace(/\\/g, "/").replace(/%5C/g, "/");

// // //     // Rest of your function...
// // //     if (
// // //       normalizedPath.startsWith("http://") ||
// // //       normalizedPath.startsWith("https://")
// // //     ) {
// // //       return normalizedPath;
// // //     }

// // //     // Check if it's a relative path starting with /media
// // //     if (normalizedPath.startsWith("/media")) {
// // //       // Prepend the base URL
// // //       return `${process.env.REACT_APP_BASE_URL}${normalizedPath}`;
// // //     }

// // //     // If it's just a filename, construct the full path
// // //     if (!normalizedPath.startsWith("/")) {
// // //       return `${process.env.REACT_APP_BASE_URL}/media/${normalizedPath}`;
// // //     }

// // //     return normalizedPath;
// // //   };

// // //   const fixEncodedBackslashes = (url) => {
// // //     if (!url) return null;
// // //     // Replace %5C with forward slash
// // //     return url.replace(/%5C/g, "/");
// // //   };

// // //   // Function to fetch admin profile
// // //   const fetchAdminProfile = (adminId) => {
// // //     if (!adminId || profilePicCache[adminId]) return;

// // //     console.log(`Fetching admin profile for ID: ${adminId}`);

// // //     // This endpoint should be adjusted to match your actual admin users API
// // //     fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${adminId}/`, {
// // //       method: "GET",
// // //       headers: {
// // //         Authorization: `Bearer ${localStorage.getItem("token")}`,
// // //       },
// // //     })
// // //       .then((response) => {
// // //         if (!response.ok) throw new Error("Admin profile fetch failed");
// // //         return response.json();
// // //       })
// // //       .then((data) => {
// // //         console.log(`Admin profile fetched for ID ${adminId}:`, data);
// // //         if (data && data.profile_picture_url) {
// // //           // Update the profile pic cache
// // //           setProfilePicCache((prev) => ({
// // //             ...prev,
// // //             [adminId]: data.profile_picture_url,
// // //           }));
// // //           console.log(
// // //             `Cached admin profile pic for ${adminId}:`,
// // //             data.profile_picture_url
// // //           );
// // //         }
// // //       })
// // //       .catch((error) => {
// // //         console.error(`Error fetching admin profile for ID ${adminId}:`, error);
// // //       });
// // //   };
// // //   useEffect(() => {
// // //     // On component mount, try to load the profile picture cache from localStorage
// // //     const savedCache = localStorage.getItem("profilePicCache");
// // //     if (savedCache) {
// // //       try {
// // //         const parsedCache = JSON.parse(savedCache);
// // //         setProfilePicCache(parsedCache);
// // //         console.log("Loaded profile pic cache from localStorage:", parsedCache);
// // //       } catch (e) {
// // //         console.error("Error parsing saved profile pic cache:", e);
// // //       }
// // //     }
// // //   }, []);

// // //   useEffect(() => {
// // //     // Save the cache to localStorage whenever it changes
// // //     if (Object.keys(profilePicCache).length > 0) {
// // //       localStorage.setItem("profilePicCache", JSON.stringify(profilePicCache));
// // //       console.log("Saved profile pic cache to localStorage");
// // //     }
// // //   }, [profilePicCache]);

// // //   useEffect(() => {
// // //     // Directly set the user's profile picture in the cache if available
// // //     if (user_id && userProfile?.profile_picture_url) {
// // //       const normalizedPic = normalizeFilePath(userProfile.profile_picture_url);
// // //       setProfilePicCache((prev) => ({
// // //         ...prev,
// // //         [user_id]: normalizedPic,
// // //       }));
// // //       console.log("Directly added user profile to cache:", normalizedPic);
// // //     }
// // //   }, [user_id, userProfile?.profile_picture_url]);

// // //   // Debug utility to log message data
// // //   const logMessageData = (message) => {
// // //     console.log("Message data:", {
// // //       sender: message.sender_id,
// // //       username: message.sender_username,
// // //       profilePic: message.sender_profile_pic,
// // //       content:
// // //         message.message?.substring(0, 20) +
// // //         (message.message?.length > 20 ? "..." : ""),
// // //     });
// // //   }; // Helper to generate initials avatar from name
// // //   const getInitialsAvatar = (firstName, lastName, username) => {
// // //     // First try to use first and last name if both exist
// // //     if (firstName && firstName.length > 0 && lastName && lastName.length > 0) {
// // //       return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
// // //     }

// // //     // Try with just first name if available
// // //     if (firstName && firstName.length > 0) {
// // //       return `${firstName.charAt(0)}${
// // //         firstName.length > 1 ? firstName.charAt(1) : ""
// // //       }`.toUpperCase();
// // //     }

// // //     // Try with just last name if available
// // //     if (lastName && lastName.length > 0) {
// // //       return `${lastName.charAt(0)}${
// // //         lastName.length > 1 ? lastName.charAt(1) : ""
// // //       }`.toUpperCase();
// // //     }

// // //     // If no first/last name, try to extract from username
// // //     if (username) {
// // //       const parts = username.split(/[\s_.-]/);
// // //       if (parts.length > 1) {
// // //         return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(
// // //           0
// // //         )}`.toUpperCase();
// // //       }
// // //       // If username is a single word, use first and last letter
// // //       if (username.length > 1) {
// // //         return `${username.charAt(0)}${username.charAt(
// // //           username.length - 1
// // //         )}`.toUpperCase();
// // //       }
// // //       // If username is only one character
// // //       if (username.length === 1) {
// // //         return `${username.charAt(0)}S`.toUpperCase();
// // //       }
// // //     }

// // //     // Default if nothing available
// // //     return "ST"; // Student
// // //   };

// // //   // Generate background color based on initials
// // //   const getAvatarColor = (initials) => {
// // //     // Create a simple hash of the initials
// // //     const hash = initials
// // //       .split("")
// // //       .reduce((acc, char) => acc + char.charCodeAt(0), 0);

// // //     // List of colors to choose from
// // //     const colors = [
// // //       "#1E88E5", // Blue
// // //       "#43A047", // Green
// // //       "#E53935", // Red
// // //       "#FB8C00", // Orange
// // //       "#8E24AA", // Purple
// // //       "#00ACC1", // Cyan
// // //       "#3949AB", // Indigo
// // //       "#00897B", // Teal
// // //       "#7CB342", // Light Green
// // //       "#C0CA33", // Lime
// // //       "#FFB300", // Amber
// // //       "#F4511E", // Deep Orange
// // //       "#6D4C41", // Brown
// // //       "#757575", // Grey
// // //       "#546E7A", // Blue Grey
// // //     ];

// // //     // Use the hash to select a color
// // //     return colors[hash % colors.length];
// // //   };

// // //   // Updated generate avatar component with better error handling and caching
// // //   const generateAvatar = (
// // //     firstName,
// // //     lastName,
// // //     username,
// // //     profilePic,
// // //     userId,
// // //     size = "small"
// // //   ) => {
// // //     // Check cache first
// // //     if (userId && profilePicCache[userId]) {
// // //       profilePic = profilePicCache[userId];
// // //     }

// // //     // If profile picture is available, render image avatar
// // //     if (profilePic) {
// // //       const normalizedProfilePic = normalizeFilePath(profilePic);

// // //       const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

// // //       return (
// // //         <div
// // //           className={`${sizeClass} rounded-full overflow-hidden border-2 border-white shadow-md`}
// // //         >
// // //           <img
// // //             src={normalizedProfilePic}
// // //             alt={`${firstName || username}'s avatar`}
// // //             className="w-full h-full object-cover"
// // //             onLoad={() => {
// // //               // Cache the successful URL
// // //               if (userId) {
// // //                 setProfilePicCache((prev) => ({
// // //                   ...prev,
// // //                   [userId]: normalizedProfilePic,
// // //                 }));
// // //               }
// // //             }}
// // //             onError={(e) => {
// // //               // Try alternative paths if the first one fails
// // //               const pathParts = normalizedProfilePic.split("/");
// // //               const filename = pathParts[pathParts.length - 1];

// // //               // Try an alternative path
// // //               const altPath = `${process.env.REACT_APP_BASE_URL}/media/profile_pictures/${filename}`;

// // //               if (normalizedProfilePic !== altPath) {
// // //                 e.target.src = altPath;
// // //                 e.target.onerror = (secondError) => {
// // //                   secondError.target.style.display = "none";
// // //                   secondError.target.parentNode.innerHTML = `
// // //                     <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
// // //                       style="background-color: ${getAvatarColor(
// // //                         getInitialsAvatar(firstName, lastName, username)
// // //                       )}">
// // //                       ${getInitialsAvatar(firstName, lastName, username)}
// // //                     </div>
// // //                   `;
// // //                 };
// // //               } else {
// // //                 // If we're already using the alternative path, fall back to initials
// // //                 e.target.style.display = "none";
// // //                 e.target.parentNode.innerHTML = `
// // //                   <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
// // //                     style="background-color: ${getAvatarColor(
// // //                       getInitialsAvatar(firstName, lastName, username)
// // //                     )}">
// // //                     ${getInitialsAvatar(firstName, lastName, username)}
// // //                   </div>
// // //                 `;
// // //               }
// // //             }}
// // //           />
// // //         </div>
// // //       );
// // //     }

// // //     // Otherwise use initials avatar
// // //     const initials = getInitialsAvatar(firstName, lastName, username);
// // //     const backgroundColor = getAvatarColor(initials);
// // //     const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

// // //     return (
// // //       <div
// // //         className={`flex items-center justify-center rounded-full ${sizeClass} text-white font-medium`}
// // //         style={{ backgroundColor }}
// // //       >
// // //         {initials}
// // //       </div>
// // //     );
// // //   };

// // //   // Generate a unique ID for a message for deduplication
// // //   const generateMessageId = (message) => {
// // //     // Use multiple fields to create a more unique ID
// // //     const timestamp = message.date_sent || message.timestamp;
// // //     const fileInfo =
// // //       message.file_urls && message.file_urls.length > 0
// // //         ? message.file_urls
// // //             .map((f) => (typeof f === "object" ? f.name : f))
// // //             .join(",")
// // //         : "";

// // //     return `${message.sender_id}_${timestamp}_${
// // //       message.message || ""
// // //     }_${fileInfo}`.replace(/\s/g, "");
// // //   };
// // //   const fetchUniversities = async (query) => {
// // //     try {
// // //       const response = await getPostFinalizedData(); // Fetch university data

// // //       if (!response.data || !Array.isArray(response.data.universities)) {
// // //         setMentionSuggestions([]);
// // //         return;
// // //       }

// // //       const universities = response.data.universities; // Extract university list

// // //       if (universities.length > 0) {
// // //         // Filter universities based on query
// // //         const filteredUniversities = universities.filter(
// // //           (uni) =>
// // //             uni.university_name &&
// // //             uni.university_name.toLowerCase().includes(query.toLowerCase())
// // //         );

// // //         setMentionSuggestions(filteredUniversities); // Update state with filtered results
// // //       } else {
// // //         setMentionSuggestions([]); // If no results, clear suggestions
// // //       }
// // //     } catch (error) {
// // //       console.error("Error fetching universities:", error);
// // //       setMentionSuggestions([]); // Handle error by clearing suggestions
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     const pathParts = location.pathname.split("/");
// // //     const roomName = pathParts[pathParts.length - 1] || "default_room";

// // //     if (!user_id) {
// // //       console.error("User ID is required for WebSocket connection");
// // //       return;
// // //     }

// // //     setCurrentRoom(roomName); // Update the current room

// // //     const socketURL = `${process.env.REACT_APP_WEB_SOCKET_URL}/${roomName}/${user_id}/`;
// // //     console.log(`Connecting to WebSocket: ${socketURL}`);

// // //     // Close the existing WebSocket connection if it exists
// // //     if (socket) {
// // //       console.log("Closing previous WebSocket connection");
// // //       socket.close();
// // //     }

// // //     // Reset the processed message IDs when changing rooms
// // //     setProcessedMessageIds(new Set());

// // //     // Create a new WebSocket connection
// // //     const newSocket = new WebSocket(socketURL);
// // //     setSocket(newSocket);
// // //     dispatch(setSocketDetails(newSocket));
// // //     newSocket.onopen = () => {
// // //       console.log("WebSocket connection established");
// // //     };

// // //     newSocket.onerror = (error) => {
// // //       console.error("WebSocket error:", error);
// // //     };

// // //     newSocket.onclose = (event) => {
// // //       console.log("WebSocket connection closed:", event);
// // //     };

// // //     newSocket.onmessage = (event) => {
// // //       const data = JSON.parse(event.data);

// // //       if (data.error) {
// // //         console.error("WebSocket error:", data.error);
// // //         return;
// // //       }

// // //       // Generate unique ID for this message using improved method
// // //       const messageId = data.message_id || generateMessageId(data);

// // //       // Skip if we've already processed this message
// // //       if (processedMessageIds.has(messageId)) {
// // //         console.log("Skipping duplicate message:", messageId);
// // //         return;
// // //       }

// // //       // Add to processed messages set immediately
// // //       setProcessedMessageIds((prev) => {
// // //         const newSet = new Set([...prev, messageId]);
// // //         return newSet;
// // //       });

// // //       // Rest of the message handling logic...
// // //       // (Handle admin profile pics, etc.)

// // //       setComments((prev) => {
// // //         const existingComments = prev[roomName] || [];

// // //         // Double-check for duplicates using content comparison
// // //         const isDuplicate = existingComments.some((existingMsg) => {
// // //           const existingId = generateMessageId(existingMsg);
// // //           return (
// // //             existingId === messageId ||
// // //             (existingMsg.sender_id === data.sender_id &&
// // //               existingMsg.message === data.message &&
// // //               JSON.stringify(existingMsg.file_urls) ===
// // //                 JSON.stringify(data.file_urls) &&
// // //               Math.abs(
// // //                 new Date(existingMsg.date_sent) - new Date(data.date_sent)
// // //               ) < 1000) // Within 1 second
// // //           );
// // //         });

// // //         if (isDuplicate) {
// // //           console.log(
// // //             "Preventing duplicate message based on content comparison"
// // //           );
// // //           return prev;
// // //         }

// // //         // Add the new message
// // //         const updatedComments = [
// // //           ...existingComments,
// // //           { ...data, message_id: messageId },
// // //         ];
// // //         updatedComments.sort(
// // //           (a, b) => new Date(a.date_sent) - new Date(b.date_sent)
// // //         );

// // //         return {
// // //           ...prev,
// // //           [roomName]: updatedComments,
// // //         };
// // //       });
// // //     };

// // //     // Cleanup function to close WebSocket before setting up a new one
// // //     return () => {
// // //       console.log("Cleaning up WebSocket connection");
// // //       if (
// // //         newSocket &&
// // //         (newSocket.readyState === WebSocket.OPEN ||
// // //           newSocket.readyState === WebSocket.CONNECTING)
// // //       ) {
// // //         newSocket.close();
// // //       }
// // //     };
// // //   }, [location.pathname, user_id]); // Updated useEffect for fetching message history with better error handling
// // //   useEffect(() => {
// // //     // Only run this if we have a room name and user ID
// // //     if (currentRoom && user_id) {
// // //       // Fetch message history from your API
// // //       fetch(
// // //         `${process.env.REACT_APP_BASE_URL}/chat_app/api/message-history/${currentRoom}/`
// // //       )
// // //         .then((response) => {
// // //           if (!response.ok) {
// // //             throw new Error(`HTTP error! status: ${response.status}`);
// // //           }
// // //           return response.json();
// // //         })
// // //         .then((data) => {
// // //           if (data.messages && Array.isArray(data.messages)) {
// // //             // Process each message to generate IDs and deduplicate
// // //             const uniqueMessages = [];
// // //             const uniqueMessageIds = new Set([...processedMessageIds]);
// // //             const tempProfileCache = { ...profilePicCache };

// // //             data.messages.forEach((message) => {
// // //               // Check profile pics in history
// // //               if (message.sender_profile_pic) {
// // //                 // Add to temporary cache
// // //                 if (message.sender_id) {
// // //                   tempProfileCache[message.sender_id] =
// // //                     message.sender_profile_pic;
// // //                 }
// // //               }

// // //               const messageId = generateMessageId(message);
// // //               if (!uniqueMessageIds.has(messageId)) {
// // //                 uniqueMessageIds.add(messageId);
// // //                 uniqueMessages.push(message);
// // //               }
// // //             });

// // //             // Update profile pic cache with any new pictures
// // //             setProfilePicCache(tempProfileCache);

// // //             // Update processed message IDs
// // //             setProcessedMessageIds(uniqueMessageIds);

// // //             // Update comments
// // //             setComments((prev) => {
// // //               const existingComments = prev[currentRoom] || [];
// // //               const combinedComments = [...existingComments, ...uniqueMessages];

// // //               // Sort by date (oldest first)
// // //               combinedComments.sort(
// // //                 (a, b) => new Date(a.date_sent) - new Date(b.date_sent)
// // //               );

// // //               return {
// // //                 ...prev,
// // //                 [currentRoom]: combinedComments,
// // //               };
// // //             });
// // //           }
// // //         })
// // //         .catch((error) => {
// // //           console.error("Error fetching message history:", error);
// // //         });
// // //     }
// // //   }, [currentRoom, user_id]);

// // //   useEffect(() => {
// // //     if (studentDetails) {
// // //       setAssignedAdmins(studentDetails.assigned_admins);
// // //     }
// // //   }, [studentDetails]);

// // //   const handleCommentChange = (e) => {
// // //     const value = e.target.value;
// // //     setComment(value);

// // //     const cursorPosition = e.target.selectionStart;
// // //     setMentionPosition(cursorPosition);

// // //     // Extract words and detect `@` mentions
// // //     const words = value.substring(0, cursorPosition).split(/\s+/);
// // //     const lastWord = words[words.length - 1];

// // //     if (lastWord.startsWith("@")) {
// // //       const searchQuery = lastWord.substring(1); // Remove `@`
// // //       if (searchQuery.length > 0) {
// // //         fetchUniversities(searchQuery); // Fetch suggestions
// // //       } else {
// // //         setMentionSuggestions([]); // Clear suggestions if no query
// // //       }
// // //     } else {
// // //       setMentionSuggestions([]); // Reset suggestions if no `@`
// // //     }
// // //   };
// // //   useEffect(() => {
// // //     // Load processed message IDs from localStorage on component mount
// // //     const savedProcessedIds = localStorage.getItem(
// // //       `processedMessageIds_${user_id}`
// // //     );
// // //     if (savedProcessedIds) {
// // //       try {
// // //         const parsedIds = JSON.parse(savedProcessedIds);
// // //         setProcessedMessageIds(new Set(parsedIds));
// // //         console.log(
// // //           "Loaded processed message IDs from localStorage:",
// // //           parsedIds.length
// // //         );
// // //       } catch (e) {
// // //         console.error("Error parsing saved processed message IDs:", e);
// // //       }
// // //     }
// // //   }, [user_id]);

// // //   useEffect(() => {
// // //     // Save processed message IDs to localStorage whenever they change
// // //     if (processedMessageIds.size > 0) {
// // //       const idsArray = Array.from(processedMessageIds);
// // //       localStorage.setItem(
// // //         `processedMessageIds_${user_id}`,
// // //         JSON.stringify(idsArray)
// // //       );
// // //       console.log("Saved processed message IDs to localStorage");
// // //     }
// // //   }, [processedMessageIds, user_id]);

// // //   /** Handle University Selection **/
// // //   const handleSelectUniversity = (university) => {
// // //     const words = comment.substring(0, mentionPosition).split(/\s+/);
// // //     words[words.length - 1] = `@${university.university_name} `; // Replace mention
// // //     const updatedComment = words.join(" ") + comment.substring(mentionPosition);

// // //     setComment(updatedComment);
// // //     setMentionSuggestions([]); // <-- This line is not triggering re-render correctly
// // //   };

// // //   const renderCommentWithMentions = (text) => {
// // //     if (!text) return "";

// // //     const mentionRegex = /(@[a-zA-Z0-9\s]+)/g;
// // //     return text.split(mentionRegex).map((part, index) => {
// // //       if (part.startsWith("@")) {
// // //         return (
// // //           <span
// // //             key={index}
// // //             className="text-white bg-blue-50 rounded px-1 font-semibold cursor-pointer"
// // //           >
// // //             {part}
// // //           </span>
// // //         );
// // //       }
// // //       return part;
// // //     });
// // //   };
// // //   const handleFileChange = (e) => {
// // //     setFile(e.target.files[0]); // Get the selected file
// // //   };

// // //   const handleKeyDown = (e) => {
// // //     if (e.key === "Enter" && !e.shiftKey) {
// // //       e.preventDefault(); // Prevent new line in textarea
// // //       handlePostClick();
// // //     }
// // //   };

// // //   const getFileIcon = (fileName) => {
// // //     if (fileName) {
// // //       const ext = fileName.split(".").pop().toLowerCase(); // Get file extension
// // //       if (["jpg", "jpeg", "png", "gif"].includes(ext))
// // //         return <IconPhoto size={20} />;
// // //       if (["pdf"].includes(ext))
// // //         return <img src={pdfImageUrl} alt="PDF Icon" width="24" height="24" />;
// // //       if (["doc", "docx"].includes(ext))
// // //         return (
// // //           <img src={docxImageUrl} alt="DOCX Icon" width="24" height="24" />
// // //         );
// // //       return "📁"; // Default icon
// // //     }
// // //   };

// // //   const handlePostClick = () => {
// // //     if (!socket || (!comment.trim() && !file)) {
// // //       alert("Cannot send an empty comment or file.");
// // //       return;
// // //     }

// // //     if (!assignedAdmins) {
// // //       alert("Assigned admins data is missing. Please try again later.");
// // //       return;
// // //     }

// // //     setIsLoading(true); // Start loader

// // //     const formData = new FormData();
// // //     if (file) formData.append("file", file);
// // //     // If only file is selected and no message, use file name as message
// // //     if (!comment.trim() && file?.name) {
// // //       const fileNameOnly = file.name.split("/").pop().split("\\").pop();
// // //       setComment(fileNameOnly); // Optional: shows the file name in the UI
// // //       formData.append("message", fileNameOnly);
// // //     } else if (comment.trim()) {
// // //       formData.append("message", comment);
// // //     }

// // //     if (comment.trim()) formData.append("message", comment);
// // //     formData.append("roomname", currentRoom);
// // //     formData.append("sender_id", user_id);
// // //     formData.append("first_name", first_name || username.split(" ")[0] || "S");
// // //     formData.append("last_name", last_name || username.split(" ")[1] || "T");

// // //     let receiverId;
// // //     if (
// // //       currentRoom === "cv_upload" ||
// // //       currentRoom === "sop" ||
// // //       currentRoom === "lor" ||
// // //       currentRoom === "university_specific_sop" ||
// // //       currentRoom === "ug_only" ||
// // //       currentRoom === "final_documents_upload"
// // //     ) {
// // //       receiverId = assignedAdmins.assigned_content_writer?.id;
// // //     } else if (currentRoom === "shortlisting_of_universities") {
// // //       receiverId = assignedAdmins.assigned_to?.id;
// // //     } else if (currentRoom === "university_application_process") {
// // //       receiverId = assignedAdmins.assigned_application_manager?.id;
// // //     } else if (currentRoom === "visa_process") {
// // //       receiverId = assignedAdmins.assigned_visa_manager?.id;
// // //     } else {
// // //       receiverId = assignedAdmins.assigned_to?.id;
// // //     }

// // //     if (!receiverId) {
// // //       alert("Receiver not found for this action. Please contact support.");
// // //       setIsLoading(false); // Stop loader
// // //       return;
// // //     }

// // //     formData.append("receiver_id", receiverId);

// // //     fetch(`${process.env.REACT_APP_BASE_URL}/chat_app/api/upload/`, {
// // //       method: "POST",
// // //       body: formData,
// // //       headers: {
// // //         Authorization: `Bearer ${localStorage.getItem("token")}`,
// // //       },
// // //     })
// // //       .then((response) => {
// // //         if (!response.ok) {
// // //           throw new Error("Failed to upload message. Please try again.");
// // //         }
// // //         return response.json();
// // //       })
// // //       .then((data) => {
// // //         console.log("File uploaded successfully:", data);
// // //         const sanitizedMessage = data.message ? data.message.trim() : "";

// // //         if (data.sender_profile_pic) {
// // //           // Fix any encoded backslashes first
// // //           const fixedPic = fixEncodedBackslashes(data.sender_profile_pic);
// // //           // Then normalize the path
// // //           const normalizedPic = normalizeFilePath(fixedPic);
// // //           setProfilePicCache((prev) => ({
// // //             ...prev,
// // //             [user_id]: normalizedPic,
// // //           }));
// // //           console.log(
// // //             "Cached profile pic from upload response:",
// // //             normalizedPic
// // //           );
// // //         }

// // //         // Generate a message ID for the message we're about to send
// // //         const outgoingMessageId = `${user_id}_${new Date().toISOString()}`;

// // //         // Pre-register this message to avoid duplication when it comes back
// // //         setProcessedMessageIds((prev) => new Set([...prev, outgoingMessageId]));

// // //         // Create a complete message object with all necessary data
// // //         const messageObject = {
// // //           message: sanitizedMessage,
// // //           file_urls: data.file_urls || [],
// // //           sender_id: user_id,
// // //           receiver_id: receiverId,
// // //           room: currentRoom,
// // //           message_id: outgoingMessageId,
// // //           sender_username: username || data.sender_username || "You",
// // //           first_name: first_name || username.split(" ")[0] || "S",
// // //           last_name: last_name || username.split(" ")[1] || "T",
// // //           sender_role: "student", // Add explicit role
// // //           // Be more aggressive about finding profile pictures from various sources
// // //           sender_profile_pic:
// // //             data.sender_profile_pic ||
// // //             studentDetails?.profile_picture_url ||
// // //             studentDetails?.profile_pic ||
// // //             profilePicCache[user_id] ||
// // //             null,
// // //           date_sent: new Date().toISOString(),
// // //         };

// // //         // Send the complete message object
// // //         setFile(null);
// // //         setComment("");
// // //         if (fileInputRef.current) {
// // //           fileInputRef.current.value = "";
// // //         }
// // //         socket.send(JSON.stringify(messageObject));
// // //       })
// // //       .catch((error) => {
// // //         console.error("Error uploading file:", error);
// // //         alert("An error occurred while sending the message. Please try again.");
// // //       })
// // //       .finally(() => {
// // //         setIsLoading(false); // Stop loader after request is done
// // //       });
// // //   };

// // //   const extractFileName = (fileName) => {
// // //     // Decode the file name
// // //     const decodedName = decodeURIComponent(fileName);

// // //     // Remove hash-like prefixes (if they exist)
// // //     return decodedName.replace(/^[a-f0-9]{32,}_/, ""); // Removes long hash prefixes if present
// // //   };

// // //   // Group messages by date
// // //   const groupMessagesByDate = (messages) => {
// // //     if (!messages || messages.length === 0) return {};

// // //     const grouped = messages.reduce((groups, message) => {
// // //       const date = new Date(message.date_sent);
// // //       const dateKey = date.toLocaleDateString("en-US", {
// // //         weekday: "short",
// // //         month: "short",
// // //         day: "numeric",
// // //       });

// // //       if (!groups[dateKey]) {
// // //         groups[dateKey] = [];
// // //       }

// // //       groups[dateKey].push(message);
// // //       return groups;
// // //     }, {});

// // //     // Reverse each group's messages and the group entries
// // //     const reversedEntries = Object.entries(grouped).reverse();
// // //     const result = {};
// // //     reversedEntries.forEach(([key, msgs]) => {
// // //       result[key] = msgs.reverse(); // reverse messages inside each group
// // //     });

// // //     return result;
// // //   };

// // //   const forceDownload = (url, filename) => {
// // //     const link = document.createElement("a");
// // //     link.href = url;
// // //     link.download = filename;
// // //     document.body.appendChild(link);
// // //     link.click();
// // //     document.body.removeChild(link);
// // //   };

// // //   const getStudentProfile = async (user_id) => {
// // //     try {
// // //       SetLoading(true);
// // //       const res = await getStudentDetails(user_id);
// // //       dispatch(setUserDetails(res.data));
// // //     } catch (err) {
// // //       console.log(err);
// // //     } finally {
// // //       SetLoading(false);
// // //     }
// // //   };

// // //   return (
// // //     <div className="flex flex-col h-full bg-gray-50 rounded-lg shadow-md overflow-hidden max-w-7xl w-full select-text">
// // //       {/* Header */}
// // //       <div className="flex justify-between items-center bg-purple-700 text-white p-4">
// // //         <h3 className="text-lg font-semibold">Comments</h3>
// // //         <button
// // //           className="shadow-md p-2 bg-purple-500 rounded-full text-white transition-transform active:scale-95 disabled:opacity-50"
// // //           onClick={() => getStudentProfile(user_id)}
// // //           disabled={loading}
// // //         >
// // //           {loading ? (
// // //             <IconReload className="animate-spin" size={20} />
// // //           ) : (
// // //             <IconReload size={20} />
// // //           )}
// // //         </button>
// // //       </div>
// // //       {/* Input Area */}
// // //       <div className="bg-white p-4 border-t border-gray-200 shadow-sm">
// // //         <div className="flex items-start">
// // //           {generateAvatar(
// // //             first_name,
// // //             last_name,
// // //             username,
// // //             studentDetails?.profile_picture_url || null,
// // //             user_id
// // //           )}
// // //           <div className="flex-grow mx-3 relative">
// // //             <textarea
// // //               value={comment}
// // //               onChange={handleCommentChange}
// // //               onKeyDown={handleKeyDown}
// // //               placeholder="Write a message..."
// // //               className="w-full border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 rounded-lg resize-none"
// // //               rows="2"
// // //             ></textarea>
// // //             {mentionSuggestions.length > 0 && (
// // //               <ul className="absolute bg-white border border-gray-300 shadow-lg list-none p-0 mt-1 max-h-48 overflow-y-auto w-full rounded-md z-10">
// // //                 {mentionSuggestions.map((university) => (
// // //                   <li
// // //                     key={university.id}
// // //                     onClick={() => handleSelectUniversity(university)}
// // //                     className="p-2 cursor-pointer hover:bg-gray-100"
// // //                   >
// // //                     {university.university_name}
// // //                   </li>
// // //                 ))}
// // //               </ul>
// // //             )}
// // //             {file && (
// // //               <div className="mt-2 p-2 bg-gray-100 rounded-md flex items-center">
// // //                 <span className="mr-2">{getFileIcon(file.name)}</span>
// // //                 <span className="text-sm font-medium truncate">
// // //                   {file.name}
// // //                 </span>
// // //                 <button
// // //                   onClick={() => {
// // //                     setFile(null);
// // //                     if (fileInputRef.current) fileInputRef.current.value = "";
// // //                   }}
// // //                   className="ml-auto text-gray-500 hover:text-red-500"
// // //                 >
// // //                   ✕
// // //                 </button>
// // //               </div>
// // //             )}
// // //           </div>
// // //           <div className="flex space-x-2">
// // //             <label className="cursor-pointer p-2 bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 flex items-center justify-center w-10 h-10 transition-colors">
// // //               <IconPaperclip size={20} />
// // //               <input
// // //                 type="file"
// // //                 ref={fileInputRef}
// // //                 onChange={handleFileChange}
// // //                 className="hidden"
// // //               />
// // //             </label>
// // //             <button
// // //               onClick={handlePostClick}
// // //               disabled={isLoading}
// // //               className="bg-purple-600 text-white p-2 rounded-full hover:bg-purple-700 transition-colors flex items-center justify-center w-10 h-10 disabled:opacity-50"
// // //             >
// // //               {isLoading ? (
// // //                 <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
// // //                   <circle
// // //                     className="opacity-25"
// // //                     cx="12"
// // //                     cy="12"
// // //                     r="10"
// // //                     stroke="currentColor"
// // //                     strokeWidth="4"
// // //                   ></circle>
// // //                   <path
// // //                     className="opacity-75"
// // //                     fill="currentColor"
// // //                     d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
// // //                   ></path>
// // //                 </svg>
// // //               ) : (
// // //                 <IconSend size={20} />
// // //               )}
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </div>
// // //       {/* Messages Container */}
// // //       <div
// // //         ref={messagesContainerRef}
// // //         className="flex-grow overflow-y-auto p-4 flex flex-col space-y-4"
// // //         style={{ maxHeight: "calc(100vh - 250px)" }}
// // //       >
// // //         {!comments[currentRoom] || comments[currentRoom].length === 0 ? (
// // //           <div className="flex items-center justify-center h-full">
// // //             <p className="text-gray-500 italic">
// // //               No messages yet. Start the conversation!
// // //             </p>
// // //           </div>
// // //         ) : (
// // //           // Group messages by date and map through them
// // //           Object.entries(groupMessagesByDate(comments[currentRoom])).map(
// // //             ([dateKey, messagesGroup], groupIndex) => (
// // //               <div key={`group-${groupIndex}`}>
// // //                 {/* Render timestamp once per group */}
// // //                 <div className="flex justify-center my-3">
// // //                   <div className="px-4 py-1 rounded-full bg-gray-200 text-xs text-gray-600">
// // //                     {dateKey}
// // //                   </div>
// // //                 </div>

// // //                 {/* Render messages in this group */}
// // //                 {messagesGroup.map((comment, index) => {
// // //                   // Determine if this is the current user's message
// // //                   const isCurrentUser = comment.sender_id === user_id;
// // //                   // Check if message is from admin
// // //                   const isAdmin =
// // //                     comment.sender_role === "admin" || comment.is_admin;

// // //                   // Check if this message is from the same sender as previous message
// // //                   const isConsecutive =
// // //                     index > 0 &&
// // //                     comment.sender_id === messagesGroup[index - 1].sender_id;
// // //                   const linkifyMessage = (message, isCurrentUser) => {
// // //                     if (!message) return "";

// // //                     const urlRegex =
// // //                       /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

// // //                     return message.replace(urlRegex, (match) => {
// // //                       const url = match.startsWith("http")
// // //                         ? match
// // //                         : `https://${match}`;
// // //                       const linkColorClass = isCurrentUser
// // //                         ? "text-white underline cursor-pointer"
// // //                         : "text-blue-700 underline hover:text-blue-900 cursor-pointer";

// // //                       return `<a href="${url}" class="${linkColorClass} break-words" target="_blank" rel="noopener noreferrer">${match}</a>`;
// // //                     });
// // //                   };

// // //                   const sanitizeAndLinkifyMessage = (
// // //                     message,
// // //                     isCurrentUser
// // //                   ) => {
// // //                     if (!message) return "";

// // //                     // Remove existing <a> tags
// // //                     const textOnly = message.replace(
// // //                       /<a[^>]*>(.*?)<\/a>/gi,
// // //                       "$1"
// // //                     );

// // //                     // Safer URL regex
// // //                     const urlRegex =
// // //                       /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

// // //                     return textOnly.replace(urlRegex, (match) => {
// // //                       const url = match.startsWith("http")
// // //                         ? match
// // //                         : `https://${match}`;
// // //                       const linkColor = isCurrentUser ? "#fff" : "#2563eb";
// // //                       return `<a href="${url}" target="_blank" rel="noopener noreferrer"
// // //               style="color:${linkColor}; text-decoration:underline;">${match}</a>`;
// // //                     });
// // //                   };

// // //                   const createMarkup = (msg) => {
// // //                     const hasAnchorTag = /<a\s+[^>]*href=/i.test(msg);
// // //                     if (hasAnchorTag) {
// // //                       // ✅ Already Quill HTML with <a>, just render safely
// // //                       return {
// // //                         __html: sanitizeAndLinkifyMessage(msg, isCurrentUser),
// // //                       };
// // //                     } else {
// // //                       // ✅ Old plain text, convert URLs into clickable links
// // //                       return { __html: linkifyMessage(msg, isCurrentUser) };
// // //                     }
// // //                   };

// // //                   return (
// // //                     <div key={`comment-${index}-${generateMessageId(comment)}`}>
// // //                       <div
// // //                         className={`flex items-start gap-2 ${
// // //                           isCurrentUser ? "flex-row-reverse" : "flex-row"
// // //                         }`}
// // //                       >
// // //                         {/* Only show avatar if it's not consecutive messages from same sender */}
// // //                         {!isConsecutive ? (
// // //                           <div className="flex-shrink-0">
// // //                             {isCurrentUser
// // //                               ? generateAvatar(
// // //                                   first_name,
// // //                                   last_name,
// // //                                   username,
// // //                                   userProfile?.profile_picture_url ||
// // //                                     profilePicCache[user_id] ||
// // //                                     null,
// // //                                   user_id
// // //                                 )
// // //                               : generateAvatar(
// // //                                   comment.first_name,
// // //                                   comment.last_name,
// // //                                   comment.sender_username || "User",
// // //                                   comment.sender_profile_pic,
// // //                                   comment.sender_id
// // //                                 )}
// // //                           </div>
// // //                         ) : (
// // //                           <div className="w-10"></div> // Spacer when avatar is hidden
// // //                         )}

// // //                         <div className="flex flex-col max-w-xs md:max-w-md">
// // //                           {/* Username (only show for first message in a sequence) */}
// // //                           {!isConsecutive && (
// // //                             <span
// // //                               className={`text-xs font-medium mb-1 ${
// // //                                 isCurrentUser ? "text-right" : "text-left"
// // //                               }`}
// // //                             >
// // //                               {isCurrentUser
// // //                                 ? "You"
// // //                                 : comment.sender_username || "User"}
// // //                             </span>
// // //                           )}

// // //                           {/* Message bubble */}
// // //                           <div
// // //                             className={`rounded-lg p-2 ${
// // //                               isCurrentUser
// // //                                 ? "bg-purple-600 text-white rounded-tr-none"
// // //                                 : isAdmin
// // //                                 ? "bg-green-100 text-green-900 rounded-tl-none"
// // //                                 : "bg-gray-200 text-gray-800 rounded-tl-none"
// // //                             }`}
// // //                           >
// // //                             {/* Message text */}
// // //                             {/* <p className="text-sm whitespace-pre-wrap">
// // //                               {renderCommentWithMentions(comment.message)}
// // //                             </p> */}
// // //                             <div
// // //                               className="prose max-w-none break-words overflow-x-auto p-1 ql-editor custom-quill-content"
// // //                               style={{
// // //                                 "--tw-prose-links": "#2563eb", // Tailwind prose link color
// // //                               }}
// // //                               dangerouslySetInnerHTML={createMarkup(
// // //                                 comment.message
// // //                               )}
// // //                             ></div>

// // //                             {/* File attachments */}
// // //                             {comment.file_urls &&
// // //                               comment.file_urls.length > 0 && (
// // //                                 <div className="mt-2 space-y-2">
// // //                                   {comment.file_urls.map(
// // //                                     (fileUrl, fileIndex) => {
// // //                                       const rawFileName = fileUrl
// // //                                         .split("/")
// // //                                         .pop();
// // //                                       const cleanedFileName =
// // //                                         extractFileName(rawFileName);
// // //                                       const parts = fileUrl.split("/").slice(3); // Remove protocol and domain
// // //                                       let path = "/" + parts.join("/");
// // //                                       // Remove duplicate "/backend" if present
// // //                                       path = path.replace(/\/backend/g, "");

// // //                                       const isImage =
// // //                                         /\.(jpe?g|png|gif)$/i.test(
// // //                                           cleanedFileName
// // //                                         );

// // //                                       return (
// // //                                         <div key={fileIndex}>
// // //                                           {isImage ? (
// // //                                             // Display images inline
// // //                                             <a
// // //                                               href={`${process.env.REACT_APP_BASE_URL}${path}`}
// // //                                               target="_blank"
// // //                                               rel="noopener noreferrer"
// // //                                               className="block mt-2"
// // //                                             >
// // //                                               <img
// // //                                                 src={`${process.env.REACT_APP_BASE_URL}${path}`}
// // //                                                 alt={cleanedFileName}
// // //                                                 className="max-h-48 rounded border border-gray-300 object-contain bg-white"
// // //                                               />
// // //                                             </a>
// // //                                           ) : (
// // //                                             // File link for non-images
// // //                                             // <a
// // //                                             //   href={`${process.env.REACT_APP_BASE_URL}${path}`}
// // //                                             //   download={cleanedFileName}
// // //                                             //   target="_blank"
// // //                                             //   rel="noopener noreferrer"
// // //                                             //   className={`flex items-center space-x-2 p-2 rounded ${
// // //                                             //     isCurrentUser
// // //                                             //       ? "bg-purple-700 text-purple-100"
// // //                                             //       : "bg-white text-gray-800"
// // //                                             //   } shadow-sm`}
// // //                                             // >
// // //                                             //   <span className="flex-shrink-0">
// // //                                             //     {getFileIcon(cleanedFileName)}
// // //                                             //   </span>
// // //                                             //   <span className="text-sm truncate">
// // //                                             //     {cleanedFileName}
// // //                                             //   </span>
// // //                                             // </a>
// // //                                             <button
// // //                                               onClick={() =>
// // //                                                 forceDownload(
// // //                                                   `${process.env.REACT_APP_BASE_URL}${path}`,
// // //                                                   cleanedFileName
// // //                                                 )
// // //                                               }
// // //                                               className={`flex items-center space-x-2 p-2 rounded ${
// // //                                                 isCurrentUser
// // //                                                   ? "bg-purple-700 text-purple-100"
// // //                                                   : "bg-white text-gray-800"
// // //                                               } shadow-sm`}
// // //                                             >
// // //                                               <span className="flex-shrink-0">
// // //                                                 {getFileIcon(cleanedFileName)}
// // //                                               </span>
// // //                                               <span className="text-sm truncate">
// // //                                                 {cleanedFileName}
// // //                                               </span>
// // //                                             </button>
// // //                                           )}
// // //                                         </div>
// // //                                       );
// // //                                     }
// // //                                   )}
// // //                                 </div>
// // //                               )}
// // //                           </div>

// // //                           {/* Message time */}
// // //                           <span
// // //                             className={`text-xs text-gray-500 mt-1 ${
// // //                               isCurrentUser ? "text-right" : "text-left"
// // //                             }`}
// // //                           >
// // //                             {new Date(comment.date_sent).toLocaleTimeString(
// // //                               [],
// // //                               {
// // //                                 hour: "2-digit",
// // //                                 minute: "2-digit",
// // //                               }
// // //                             )}
// // //                           </span>
// // //                         </div>
// // //                       </div>
// // //                     </div>
// // //                   );
// // //                 })}
// // //               </div>
// // //             )
// // //           )
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Comments;
// // import React, { useEffect, useRef, useState } from "react";
// // import { useDispatch, useSelector } from "react-redux";
// // import { useLocation } from "react-router-dom";

// // import {
// //   getPostFinalizedData,
// //   getStudentDetails,
// // } from "../../services/admin.services";
// // import docxImageUrl from "../../assets/docx.png";
// // import pdfImageUrl from "../../assets/pdf.jpg";
// // import {
// //   IconPhoto,
// //   IconSend,
// //   IconPaperclip,
// //   IconReload,
// // } from "@tabler/icons-react";
// // import {
// //   setSocketDetails,
// //   setUserDetails,
// // } from "../../state/reducers/userSlice";

// // const Comments = ({ activeTab }) => {
// //   const location = useLocation();
// //   const studentDetails = useSelector((state) => state.user.userDetails);
// //   const [comment, setComment] = useState("");
// //   const [comments, setComments] = useState({});
// //   const [processedMessageIds, setProcessedMessageIds] = useState(new Set());
// //   const [currentRoom, setCurrentRoom] = useState("");
// //   const [socket, setSocket] = useState(null);
// //   const [assignedAdmins, setAssignedAdmins] = useState([]);
// //   const [files, setFiles] = useState([]); // ✅ CHANGED: Array instead of single file
// //   const user_id = useSelector((state) => state.user.user_id);
// //   const username = useSelector((state) => state.user.username || "");
// //   const first_name = useSelector((state) => state.user.first_name || "");
// //   const last_name = useSelector((state) => state.user.last_name || "");
// //   const [mentionPosition, setMentionPosition] = useState(null);
// //   const [mentionSuggestions, setMentionSuggestions] = useState([]);
// //   const [loading, SetLoading] = useState(false);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [profilePicCache, setProfilePicCache] = useState({});
// //   const dispatch = useDispatch();
// //   const fileInputRef = useRef(null);
// //   const messagesContainerRef = useRef(null);
// //   const userProfile = useSelector((state) => state.user.profile || {});

// //   // ✅ NEW: Helper function to convert URLs to attachments
// //   const toAttachments = (urls = [], fallbackNames = []) =>
// //     urls.map((u, i) => ({
// //       url: u,
// //       name:
// //         fallbackNames[i] || extractFileName(String(u).split("/").pop() || ""),
// //     }));

// //   const normalizeFilePath = (path) => {
// //     if (!path) return null;

// //     let normalizedPath = path.replace(/\\/g, "/").replace(/%5C/g, "/");

// //     if (
// //       normalizedPath.startsWith("http://") ||
// //       normalizedPath.startsWith("https://")
// //     ) {
// //       return normalizedPath;
// //     }

// //     if (normalizedPath.startsWith("/media")) {
// //       return `${process.env.REACT_APP_BASE_URL}${normalizedPath}`;
// //     }

// //     if (!normalizedPath.startsWith("/")) {
// //       return `${process.env.REACT_APP_BASE_URL}/media/${normalizedPath}`;
// //     }

// //     return normalizedPath;
// //   };

// //   const fixEncodedBackslashes = (url) => {
// //     if (!url) return null;
// //     return url.replace(/%5C/g, "/");
// //   };

// //   const fetchAdminProfile = (adminId) => {
// //     if (!adminId || profilePicCache[adminId]) return;

// //     console.log(`Fetching admin profile for ID: ${adminId}`);

// //     fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${adminId}/`, {
// //       method: "GET",
// //       headers: {
// //         Authorization: `Bearer ${localStorage.getItem("token")}`,
// //       },
// //     })
// //       .then((response) => {
// //         if (!response.ok) throw new Error("Admin profile fetch failed");
// //         return response.json();
// //       })
// //       .then((data) => {
// //         console.log(`Admin profile fetched for ID ${adminId}:`, data);
// //         if (data && data.profile_picture_url) {
// //           setProfilePicCache((prev) => ({
// //             ...prev,
// //             [adminId]: data.profile_picture_url,
// //           }));
// //           console.log(
// //             `Cached admin profile pic for ${adminId}:`,
// //             data.profile_picture_url
// //           );
// //         }
// //       })
// //       .catch((error) => {
// //         console.error(`Error fetching admin profile for ID ${adminId}:`, error);
// //       });
// //   };

// //   useEffect(() => {
// //     const savedCache = localStorage.getItem("profilePicCache");
// //     if (savedCache) {
// //       try {
// //         const parsedCache = JSON.parse(savedCache);
// //         setProfilePicCache(parsedCache);
// //         console.log("Loaded profile pic cache from localStorage:", parsedCache);
// //       } catch (e) {
// //         console.error("Error parsing saved profile pic cache:", e);
// //       }
// //     }
// //   }, []);

// //   useEffect(() => {
// //     if (Object.keys(profilePicCache).length > 0) {
// //       localStorage.setItem("profilePicCache", JSON.stringify(profilePicCache));
// //       console.log("Saved profile pic cache to localStorage");
// //     }
// //   }, [profilePicCache]);

// //   useEffect(() => {
// //     if (user_id && userProfile?.profile_picture_url) {
// //       const normalizedPic = normalizeFilePath(userProfile.profile_picture_url);
// //       setProfilePicCache((prev) => ({
// //         ...prev,
// //         [user_id]: normalizedPic,
// //       }));
// //       console.log("Directly added user profile to cache:", normalizedPic);
// //     }
// //   }, [user_id, userProfile?.profile_picture_url]);

// //   const logMessageData = (message) => {
// //     console.log("Message data:", {
// //       sender: message.sender_id,
// //       username: message.sender_username,
// //       profilePic: message.sender_profile_pic,
// //       content:
// //         message.message?.substring(0, 20) +
// //         (message.message?.length > 20 ? "..." : ""),
// //     });
// //   };

// //   const getInitialsAvatar = (firstName, lastName, username) => {
// //     if (firstName && firstName.length > 0 && lastName && lastName.length > 0) {
// //       return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
// //     }

// //     if (firstName && firstName.length > 0) {
// //       return `${firstName.charAt(0)}${
// //         firstName.length > 1 ? firstName.charAt(1) : ""
// //       }`.toUpperCase();
// //     }

// //     if (lastName && lastName.length > 0) {
// //       return `${lastName.charAt(0)}${
// //         lastName.length > 1 ? lastName.charAt(1) : ""
// //       }`.toUpperCase();
// //     }

// //     if (username) {
// //       const parts = username.split(/[\s_.-]/);
// //       if (parts.length > 1) {
// //         return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(
// //           0
// //         )}`.toUpperCase();
// //       }
// //       if (username.length > 1) {
// //         return `${username.charAt(0)}${username.charAt(
// //           username.length - 1
// //         )}`.toUpperCase();
// //       }
// //       if (username.length === 1) {
// //         return `${username.charAt(0)}S`.toUpperCase();
// //       }
// //     }

// //     return "ST";
// //   };

// //   const getAvatarColor = (initials) => {
// //     const hash = initials
// //       .split("")
// //       .reduce((acc, char) => acc + char.charCodeAt(0), 0);

// //     const colors = [
// //       "#1E88E5",
// //       "#43A047",
// //       "#E53935",
// //       "#FB8C00",
// //       "#8E24AA",
// //       "#00ACC1",
// //       "#3949AB",
// //       "#00897B",
// //       "#7CB342",
// //       "#C0CA33",
// //       "#FFB300",
// //       "#F4511E",
// //       "#6D4C41",
// //       "#757575",
// //       "#546E7A",
// //     ];

// //     return colors[hash % colors.length];
// //   };

// //   const generateAvatar = (
// //     firstName,
// //     lastName,
// //     username,
// //     profilePic,
// //     userId,
// //     size = "small"
// //   ) => {
// //     if (userId && profilePicCache[userId]) {
// //       profilePic = profilePicCache[userId];
// //     }

// //     if (profilePic) {
// //       const normalizedProfilePic = normalizeFilePath(profilePic);
// //       const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

// //       return (
// //         <div
// //           className={`${sizeClass} rounded-full overflow-hidden border-2 border-white shadow-md`}
// //         >
// //           <img
// //             src={normalizedProfilePic}
// //             alt={`${firstName || username}'s avatar`}
// //             className="w-full h-full object-cover"
// //             onLoad={() => {
// //               if (userId) {
// //                 setProfilePicCache((prev) => ({
// //                   ...prev,
// //                   [userId]: normalizedProfilePic,
// //                 }));
// //               }
// //             }}
// //             onError={(e) => {
// //               const pathParts = normalizedProfilePic.split("/");
// //               const filename = pathParts[pathParts.length - 1];
// //               const altPath = `${process.env.REACT_APP_BASE_URL}/media/profile_pictures/${filename}`;

// //               if (normalizedProfilePic !== altPath) {
// //                 e.target.src = altPath;
// //                 e.target.onerror = (secondError) => {
// //                   secondError.target.style.display = "none";
// //                   secondError.target.parentNode.innerHTML = `
// //                     <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
// //                       style="background-color: ${getAvatarColor(
// //                         getInitialsAvatar(firstName, lastName, username)
// //                       )}">
// //                       ${getInitialsAvatar(firstName, lastName, username)}
// //                     </div>
// //                   `;
// //                 };
// //               } else {
// //                 e.target.style.display = "none";
// //                 e.target.parentNode.innerHTML = `
// //                   <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
// //                     style="background-color: ${getAvatarColor(
// //                       getInitialsAvatar(firstName, lastName, username)
// //                     )}">
// //                     ${getInitialsAvatar(firstName, lastName, username)}
// //                   </div>
// //                 `;
// //               }
// //             }}
// //           />
// //         </div>
// //       );
// //     }

// //     const initials = getInitialsAvatar(firstName, lastName, username);
// //     const backgroundColor = getAvatarColor(initials);
// //     const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

// //     return (
// //       <div
// //         className={`flex items-center justify-center rounded-full ${sizeClass} text-white font-medium`}
// //         style={{ backgroundColor }}
// //       >
// //         {initials}
// //       </div>
// //     );
// //   };

// //   const generateMessageId = (message) => {
// //     const timestamp = message.date_sent || message.timestamp;
// //     const fileInfo =
// //       message.file_urls && message.file_urls.length > 0
// //         ? message.file_urls
// //             .map((f) => (typeof f === "object" ? f.name : f))
// //             .join(",")
// //         : "";

// //     return `${message.sender_id}_${timestamp}_${
// //       message.message || ""
// //     }_${fileInfo}`.replace(/\s/g, "");
// //   };

// //   const fetchUniversities = async (query) => {
// //     try {
// //       const response = await getPostFinalizedData();

// //       if (!response.data || !Array.isArray(response.data.universities)) {
// //         setMentionSuggestions([]);
// //         return;
// //       }

// //       const universities = response.data.universities;

// //       if (universities.length > 0) {
// //         const filteredUniversities = universities.filter(
// //           (uni) =>
// //             uni.university_name &&
// //             uni.university_name.toLowerCase().includes(query.toLowerCase())
// //         );

// //         setMentionSuggestions(filteredUniversities);
// //       } else {
// //         setMentionSuggestions([]);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching universities:", error);
// //       setMentionSuggestions([]);
// //     }
// //   };

// //   useEffect(() => {
// //     const pathParts = location.pathname.split("/");
// //     const roomName = pathParts[pathParts.length - 1] || "default_room";

// //     if (!user_id) {
// //       console.error("User ID is required for WebSocket connection");
// //       return;
// //     }

// //     setCurrentRoom(roomName);

// //     const socketURL = `${process.env.REACT_APP_WEB_SOCKET_URL}/${roomName}/${user_id}/`;
// //     console.log(`Connecting to WebSocket: ${socketURL}`);

// //     if (socket) {
// //       console.log("Closing previous WebSocket connection");
// //       socket.close();
// //     }

// //     setProcessedMessageIds(new Set());

// //     const newSocket = new WebSocket(socketURL);
// //     setSocket(newSocket);
// //     dispatch(setSocketDetails(newSocket));

// //     newSocket.onopen = () => {
// //       console.log("WebSocket connection established");
// //     };

// //     newSocket.onerror = (error) => {
// //       console.error("WebSocket error:", error);
// //     };

// //     newSocket.onclose = (event) => {
// //       console.log("WebSocket connection closed:", event);
// //     };

// //     newSocket.onmessage = (event) => {
// //       const data = JSON.parse(event.data);

// //       if (data.error) {
// //         console.error("WebSocket error:", data.error);
// //         return;
// //       }

// //       const messageId = data.message_id || generateMessageId(data);

// //       if (processedMessageIds.has(messageId)) {
// //         console.log("Skipping duplicate message:", messageId);
// //         return;
// //       }

// //       setProcessedMessageIds((prev) => {
// //         const newSet = new Set([...prev, messageId]);
// //         return newSet;
// //       });

// //       setComments((prev) => {
// //         const existingComments = prev[roomName] || [];

// //         const isDuplicate = existingComments.some((existingMsg) => {
// //           const existingId = generateMessageId(existingMsg);
// //           return (
// //             existingId === messageId ||
// //             (existingMsg.sender_id === data.sender_id &&
// //               existingMsg.message === data.message &&
// //               JSON.stringify(existingMsg.file_urls) ===
// //                 JSON.stringify(data.file_urls) &&
// //               Math.abs(
// //                 new Date(existingMsg.date_sent) - new Date(data.date_sent)
// //               ) < 1000)
// //           );
// //         });

// //         if (isDuplicate) {
// //           console.log(
// //             "Preventing duplicate message based on content comparison"
// //           );
// //           return prev;
// //         }

// //         const updatedComments = [
// //           ...existingComments,
// //           { ...data, message_id: messageId },
// //         ];
// //         updatedComments.sort(
// //           (a, b) => new Date(a.date_sent) - new Date(b.date_sent)
// //         );

// //         return {
// //           ...prev,
// //           [roomName]: updatedComments,
// //         };
// //       });
// //     };

// //     return () => {
// //       console.log("Cleaning up WebSocket connection");
// //       if (
// //         newSocket &&
// //         (newSocket.readyState === WebSocket.OPEN ||
// //           newSocket.readyState === WebSocket.CONNECTING)
// //       ) {
// //         newSocket.close();
// //       }
// //     };
// //   }, [location.pathname, user_id]);

// //   useEffect(() => {
// //     if (currentRoom && user_id) {
// //       fetch(
// //         `${process.env.REACT_APP_BASE_URL}/chat_app/api/message-history/${currentRoom}/`
// //       )
// //         .then((response) => {
// //           if (!response.ok) {
// //             throw new Error(`HTTP error! status: ${response.status}`);
// //           }
// //           return response.json();
// //         })
// //         .then((data) => {
// //           if (data.messages && Array.isArray(data.messages)) {
// //             const uniqueMessages = [];
// //             const uniqueMessageIds = new Set([...processedMessageIds]);
// //             const tempProfileCache = { ...profilePicCache };

// //             data.messages.forEach((message) => {
// //               if (message.sender_profile_pic) {
// //                 if (message.sender_id) {
// //                   tempProfileCache[message.sender_id] =
// //                     message.sender_profile_pic;
// //                 }
// //               }

// //               const messageId = generateMessageId(message);
// //               if (!uniqueMessageIds.has(messageId)) {
// //                 uniqueMessageIds.add(messageId);
// //                 uniqueMessages.push(message);
// //               }
// //             });

// //             setProfilePicCache(tempProfileCache);
// //             setProcessedMessageIds(uniqueMessageIds);

// //             setComments((prev) => {
// //               const existingComments = prev[currentRoom] || [];
// //               const combinedComments = [...existingComments, ...uniqueMessages];

// //               combinedComments.sort(
// //                 (a, b) => new Date(a.date_sent) - new Date(b.date_sent)
// //               );

// //               return {
// //                 ...prev,
// //                 [currentRoom]: combinedComments,
// //               };
// //             });
// //           }
// //         })
// //         .catch((error) => {
// //           console.error("Error fetching message history:", error);
// //         });
// //     }
// //   }, [currentRoom, user_id]);

// //   useEffect(() => {
// //     if (studentDetails) {
// //       setAssignedAdmins(studentDetails.assigned_admins);
// //     }
// //   }, [studentDetails]);

// //   const handleCommentChange = (e) => {
// //     const value = e.target.value;
// //     setComment(value);

// //     const cursorPosition = e.target.selectionStart;
// //     setMentionPosition(cursorPosition);

// //     const words = value.substring(0, cursorPosition).split(/\s+/);
// //     const lastWord = words[words.length - 1];

// //     if (lastWord.startsWith("@")) {
// //       const searchQuery = lastWord.substring(1);
// //       if (searchQuery.length > 0) {
// //         fetchUniversities(searchQuery);
// //       } else {
// //         setMentionSuggestions([]);
// //       }
// //     } else {
// //       setMentionSuggestions([]);
// //     }
// //   };

// //   useEffect(() => {
// //     const savedProcessedIds = localStorage.getItem(
// //       `processedMessageIds_${user_id}`
// //     );
// //     if (savedProcessedIds) {
// //       try {
// //         const parsedIds = JSON.parse(savedProcessedIds);
// //         setProcessedMessageIds(new Set(parsedIds));
// //         console.log(
// //           "Loaded processed message IDs from localStorage:",
// //           parsedIds.length
// //         );
// //       } catch (e) {
// //         console.error("Error parsing saved processed message IDs:", e);
// //       }
// //     }
// //   }, [user_id]);

// //   useEffect(() => {
// //     if (processedMessageIds.size > 0) {
// //       const idsArray = Array.from(processedMessageIds);
// //       localStorage.setItem(
// //         `processedMessageIds_${user_id}`,
// //         JSON.stringify(idsArray)
// //       );
// //       console.log("Saved processed message IDs to localStorage");
// //     }
// //   }, [processedMessageIds, user_id]);

// //   const handleSelectUniversity = (university) => {
// //     const words = comment.substring(0, mentionPosition).split(/\s+/);
// //     words[words.length - 1] = `@${university.university_name} `;
// //     const updatedComment = words.join(" ") + comment.substring(mentionPosition);

// //     setComment(updatedComment);
// //     setMentionSuggestions([]);
// //   };

// //   const renderCommentWithMentions = (text) => {
// //     if (!text) return "";

// //     const mentionRegex = /(@[a-zA-Z0-9\s]+)/g;
// //     return text.split(mentionRegex).map((part, index) => {
// //       if (part.startsWith("@")) {
// //         return (
// //           <span
// //             key={index}
// //             className="text-white bg-blue-50 rounded px-1 font-semibold cursor-pointer"
// //           >
// //             {part}
// //           </span>
// //         );
// //       }
// //       return part;
// //     });
// //   };

// //   // ✅ CHANGED: Handle multiple file selection
// //   const handleFileChange = (e) => {
// //     const selectedFiles = Array.from(e.target.files);
// //     setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
// //   };

// //   // ✅ NEW: Remove individual file
// //   const handleRemoveFile = (indexToRemove) => {
// //     setFiles((prevFiles) =>
// //       prevFiles.filter((_, index) => index !== indexToRemove)
// //     );
// //   };

// //   const handleKeyDown = (e) => {
// //     if (e.key === "Enter" && !e.shiftKey) {
// //       e.preventDefault();
// //       handlePostClick();
// //     }
// //   };

// //   const getFileIcon = (fileName) => {
// //     if (fileName) {
// //       const ext = fileName.split(".").pop().toLowerCase();
// //       if (["jpg", "jpeg", "png", "gif"].includes(ext))
// //         return <IconPhoto size={20} />;
// //       if (["pdf"].includes(ext))
// //         return <img src={pdfImageUrl} alt="PDF Icon" width="24" height="24" />;
// //       if (["doc", "docx"].includes(ext))
// //         return (
// //           <img src={docxImageUrl} alt="DOCX Icon" width="24" height="24" />
// //         );
// //       return "📁";
// //     }
// //   };

// //   // ✅ UPDATED: Handle multiple files in upload
// //   const handlePostClick = () => {
// //     if (!socket || (!comment.trim() && files.length === 0)) {
// //       alert("Cannot send an empty comment or file.");
// //       return;
// //     }

// //     if (!assignedAdmins) {
// //       alert("Assigned admins data is missing. Please try again later.");
// //       return;
// //     }

// //     setIsLoading(true);

// //     const formData = new FormData();

// //     // ✅ Append ALL files to FormData
// //     files.forEach((file) => {
// //       formData.append(`file`, file);
// //     });

// //     // Handle message
// //     if (!comment.trim() && files.length > 0) {
// //       const fileNames = files
// //         .map((f) => f.name.split("/").pop().split("\\").pop())
// //         .join(", ");
// //       setComment(fileNames);
// //       formData.append("message", fileNames);
// //     } else if (comment.trim()) {
// //       formData.append("message", comment);
// //     }

// //     formData.append("roomname", currentRoom);
// //     formData.append("sender_id", user_id);
// //     formData.append("first_name", first_name || username.split(" ")[0] || "S");
// //     formData.append("last_name", last_name || username.split(" ")[1] || "T");

// //     let receiverId;
// //     if (
// //       currentRoom === "cv_upload" ||
// //       currentRoom === "sop" ||
// //       currentRoom === "lor" ||
// //       currentRoom === "university_specific_sop" ||
// //       currentRoom === "ug_only" ||
// //       currentRoom === "final_documents_upload"
// //     ) {
// //       receiverId = assignedAdmins.assigned_content_writer?.id;
// //     } else if (currentRoom === "shortlisting_of_universities") {
// //       receiverId = assignedAdmins.assigned_to?.id;
// //     } else if (currentRoom === "university_application_process") {
// //       receiverId = assignedAdmins.assigned_application_manager?.id;
// //     } else if (currentRoom === "visa_process") {
// //       receiverId = assignedAdmins.assigned_visa_manager?.id;
// //     } else {
// //       receiverId = assignedAdmins.assigned_to?.id;
// //     }

// //     if (!receiverId) {
// //       alert("Receiver not found for this action. Please contact support.");
// //       setIsLoading(false);
// //       return;
// //     }

// //     formData.append("receiver_id", receiverId);

// //     fetch(`${process.env.REACT_APP_BASE_URL}/chat_app/api/upload/`, {
// //       method: "POST",
// //       body: formData,
// //       headers: {
// //         Authorization: `Bearer ${localStorage.getItem("token")}`,
// //       },
// //     })
// //       .then((response) => {
// //         if (!response.ok) {
// //           throw new Error("Failed to upload message. Please try again.");
// //         }
// //         return response.json();
// //       })
// //       .then((data) => {
// //         console.log("Files uploaded successfully:", data);
// //         const sanitizedMessage = data.message ? data.message.trim() : "";

// //         if (data.sender_profile_pic) {
// //           const fixedPic = fixEncodedBackslashes(data.sender_profile_pic);
// //           const normalizedPic = normalizeFilePath(fixedPic);
// //           setProfilePicCache((prev) => ({
// //             ...prev,
// //             [user_id]: normalizedPic,
// //           }));
// //           console.log(
// //             "Cached profile pic from upload response:",
// //             normalizedPic
// //           );
// //         }

// //         const outgoingMessageId = `${user_id}_${new Date().toISOString()}`;

// //         setProcessedMessageIds((prev) => new Set([...prev, outgoingMessageId]));

// //         // ✅ Build attachments with original file names
// //         const priorNames = files.map((f) => f.name);
// //         const finalUrls = (data.file_urls || []).map((u) =>
// //           normalizeFilePath(fixEncodedBackslashes(u))
// //         );
// //         const finalAttachments = toAttachments(finalUrls, priorNames);

// //         const messageObject = {
// //           message: sanitizedMessage,
// //           file_urls: finalUrls,
// //           file_attachments: finalAttachments,
// //           sender_id: user_id,
// //           receiver_id: receiverId,
// //           room: currentRoom,
// //           message_id: outgoingMessageId,
// //           sender_username: username || data.sender_username || "You",
// //           first_name: first_name || username.split(" ")[0] || "S",
// //           last_name: last_name || username.split(" ")[1] || "T",
// //           sender_role: "student",
// //           sender_profile_pic:
// //             data.sender_profile_pic ||
// //             studentDetails?.profile_picture_url ||
// //             studentDetails?.profile_pic ||
// //             profilePicCache[user_id] ||
// //             null,
// //           date_sent: new Date().toISOString(),
// //         };

// //         // ✅ Clear ALL files
// //         setFiles([]);
// //         setComment("");
// //         if (fileInputRef.current) {
// //           fileInputRef.current.value = "";
// //         }
// //         socket.send(JSON.stringify(messageObject));
// //       })
// //       .catch((error) => {
// //         console.error("Error uploading files:", error);
// //         alert("An error occurred while sending the message. Please try again.");
// //       })
// //       .finally(() => {
// //         setIsLoading(false);
// //       });
// //   };

// //   const extractFileName = (fileName) => {
// //     const decodedName = decodeURIComponent(fileName);
// //     return decodedName.replace(/^[a-f0-9]{32,}_/, "");
// //   };

// //   const groupMessagesByDate = (messages) => {
// //     if (!messages || messages.length === 0) return {};

// //     const grouped = messages.reduce((groups, message) => {
// //       const date = new Date(message.date_sent);
// //       const dateKey = date.toLocaleDateString("en-US", {
// //         weekday: "short",
// //         month: "short",
// //         day: "numeric",
// //       });

// //       if (!groups[dateKey]) {
// //         groups[dateKey] = [];
// //       }

// //       groups[dateKey].push(message);
// //       return groups;
// //     }, {});

// //     const reversedEntries = Object.entries(grouped).reverse();
// //     const result = {};
// //     reversedEntries.forEach(([key, msgs]) => {
// //       result[key] = msgs.reverse();
// //     });

// //     return result;
// //   };

// //   const forceDownload = (url, filename) => {
// //     const link = document.createElement("a");
// //     link.href = url;
// //     link.download = filename;
// //     document.body.appendChild(link);
// //     link.click();
// //     document.body.removeChild(link);
// //   };

// //   const getStudentProfile = async (user_id) => {
// //     try {
// //       SetLoading(true);
// //       const res = await getStudentDetails(user_id);
// //       dispatch(setUserDetails(res.data));
// //     } catch (err) {
// //       console.log(err);
// //     } finally {
// //       SetLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="flex flex-col h-full bg-gray-50 rounded-lg shadow-md overflow-hidden max-w-7xl w-full select-text">
// //       <div className="flex justify-between items-center bg-purple-700 text-white p-4">
// //         <h3 className="text-lg font-semibold">Comments</h3>
// //         <button
// //           className="shadow-md p-2 bg-purple-500 rounded-full text-white transition-transform active:scale-95 disabled:opacity-50"
// //           onClick={() => getStudentProfile(user_id)}
// //           disabled={loading}
// //         >
// //           {loading ? (
// //             <IconReload className="animate-spin" size={20} />
// //           ) : (
// //             <IconReload size={20} />
// //           )}
// //         </button>
// //       </div>

// //       <div className="bg-white p-4 border-t border-gray-200 shadow-sm">
// //         <div className="flex items-start">
// //           {generateAvatar(
// //             first_name,
// //             last_name,
// //             username,
// //             studentDetails?.profile_picture_url || null,
// //             user_id
// //           )}
// //           <div className="flex-grow mx-3 relative">
// //             <textarea
// //               value={comment}
// //               onChange={handleCommentChange}
// //               onKeyDown={handleKeyDown}
// //               placeholder="Write a message..."
// //               className="w-full border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 rounded-lg resize-none"
// //               rows="2"
// //             ></textarea>
// //             {mentionSuggestions.length > 0 && (
// //               <ul className="absolute bg-white border border-gray-300 shadow-lg list-none p-0 mt-1 max-h-48 overflow-y-auto w-full rounded-md z-10">
// //                 {mentionSuggestions.map((university) => (
// //                   <li
// //                     key={university.id}
// //                     onClick={() => handleSelectUniversity(university)}
// //                     className="p-2 cursor-pointer hover:bg-gray-100"
// //                   >
// //                     {university.university_name}
// //                   </li>
// //                 ))}
// //               </ul>
// //             )}
// //             {/* ✅ UPDATED: Show ALL selected files */}
// //             {files.length > 0 && (
// //               <div className="mt-2 space-y-2">
// //                 {files.map((file, index) => (
// //                   <div
// //                     key={index}
// //                     className="p-2 bg-gray-100 rounded-md flex items-center"
// //                   >
// //                     <span className="mr-2">{getFileIcon(file.name)}</span>
// //                     <span className="text-sm font-medium truncate flex-1">
// //                       {file.name}
// //                     </span>
// //                     <button
// //                       onClick={() => handleRemoveFile(index)}
// //                       className="ml-2 text-gray-500 hover:text-red-500 flex-shrink-0"
// //                     >
// //                       ✕
// //                     </button>
// //                   </div>
// //                 ))}
// //               </div>
// //             )}
// //           </div>
// //           <div className="flex space-x-2">
// //             <label className="cursor-pointer p-2 bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 flex items-center justify-center w-10 h-10 transition-colors">
// //               <IconPaperclip size={20} />
// //               <input
// //                 type="file"
// //                 ref={fileInputRef}
// //                 onChange={handleFileChange}
// //                 className="hidden"
// //                 multiple
// //               />
// //             </label>
// //             <button
// //               onClick={handlePostClick}
// //               disabled={isLoading}
// //               className="bg-purple-600 text-white p-2 rounded-full hover:bg-purple-700 transition-colors flex items-center justify-center w-10 h-10 disabled:opacity-50"
// //             >
// //               {isLoading ? (
// //                 <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
// //                   <circle
// //                     className="opacity-25"
// //                     cx="12"
// //                     cy="12"
// //                     r="10"
// //                     stroke="currentColor"
// //                     strokeWidth="4"
// //                   ></circle>
// //                   <path
// //                     className="opacity-75"
// //                     fill="currentColor"
// //                     d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
// //                   ></path>
// //                 </svg>
// //               ) : (
// //                 <IconSend size={20} />
// //               )}
// //             </button>
// //           </div>
// //         </div>
// //       </div>

// //       <div
// //         ref={messagesContainerRef}
// //         className="flex-grow overflow-y-auto p-4 flex flex-col space-y-4"
// //         style={{ maxHeight: "calc(100vh - 250px)" }}
// //       >
// //         {!comments[currentRoom] || comments[currentRoom].length === 0 ? (
// //           <div className="flex items-center justify-center h-full">
// //             <p className="text-gray-500 italic">
// //               No messages yet. Start the conversation!
// //             </p>
// //           </div>
// //         ) : (
// //           Object.entries(groupMessagesByDate(comments[currentRoom])).map(
// //             ([dateKey, messagesGroup], groupIndex) => (
// //               <div key={`group-${groupIndex}`}>
// //                 <div className="flex justify-center my-3">
// //                   <div className="px-4 py-1 rounded-full bg-gray-200 text-xs text-gray-600">
// //                     {dateKey}
// //                   </div>
// //                 </div>

// //                 {messagesGroup.map((comment, index) => {
// //                   const isCurrentUser = comment.sender_id === user_id;
// //                   const isAdmin =
// //                     comment.sender_role === "admin" || comment.is_admin;
// //                   const isConsecutive =
// //                     index > 0 &&
// //                     comment.sender_id === messagesGroup[index - 1].sender_id;

// //                   const linkifyMessage = (message, isCurrentUser) => {
// //                     if (!message) return "";

// //                     const urlRegex =
// //                       /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

// //                     return message.replace(urlRegex, (match) => {
// //                       const url = match.startsWith("http")
// //                         ? match
// //                         : `https://${match}`;
// //                       const linkColorClass = isCurrentUser
// //                         ? "text-white underline cursor-pointer"
// //                         : "text-blue-700 underline hover:text-blue-900 cursor-pointer";

// //                       return `<a href="${url}" class="${linkColorClass} break-words" target="_blank" rel="noopener noreferrer">${match}</a>`;
// //                     });
// //                   };

// //                   const sanitizeAndLinkifyMessage = (
// //                     message,
// //                     isCurrentUser
// //                   ) => {
// //                     if (!message) return "";

// //                     const textOnly = message.replace(
// //                       /<a[^>]*>(.*?)<\/a>/gi,
// //                       "$1"
// //                     );

// //                     const urlRegex =
// //                       /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

// //                     return textOnly.replace(urlRegex, (match) => {
// //                       const url = match.startsWith("http")
// //                         ? match
// //                         : `https://${match}`;
// //                       const linkColor = isCurrentUser ? "#fff" : "#2563eb";
// //                       return `<a href="${url}" target="_blank" rel="noopener noreferrer"
// //               style="color:${linkColor}; text-decoration:underline;">${match}</a>`;
// //                     });
// //                   };

// //                   const createMarkup = (msg) => {
// //                     const hasAnchorTag = /<a\s+[^>]*href=/i.test(msg);
// //                     if (hasAnchorTag) {
// //                       return {
// //                         __html: sanitizeAndLinkifyMessage(msg, isCurrentUser),
// //                       };
// //                     } else {
// //                       return { __html: linkifyMessage(msg, isCurrentUser) };
// //                     }
// //                   };

// //                   return (
// //                     <div key={`comment-${index}-${generateMessageId(comment)}`}>
// //                       <div
// //                         className={`flex items-start gap-2 ${
// //                           isCurrentUser ? "flex-row-reverse" : "flex-row"
// //                         }`}
// //                       >
// //                         {!isConsecutive ? (
// //                           <div className="flex-shrink-0">
// //                             {isCurrentUser
// //                               ? generateAvatar(
// //                                   first_name,
// //                                   last_name,
// //                                   username,
// //                                   userProfile?.profile_picture_url ||
// //                                     profilePicCache[user_id] ||
// //                                     null,
// //                                   user_id
// //                                 )
// //                               : generateAvatar(
// //                                   comment.first_name,
// //                                   comment.last_name,
// //                                   comment.sender_username || "User",
// //                                   comment.sender_profile_pic,
// //                                   comment.sender_id
// //                                 )}
// //                           </div>
// //                         ) : (
// //                           <div className="w-10"></div>
// //                         )}

// //                         <div className="flex flex-col max-w-xs md:max-w-md">
// //                           {!isConsecutive && (
// //                             <span
// //                               className={`text-xs font-medium mb-1 ${
// //                                 isCurrentUser ? "text-right" : "text-left"
// //                               }`}
// //                             >
// //                               {isCurrentUser
// //                                 ? "You"
// //                                 : comment.sender_username || "User"}
// //                             </span>
// //                           )}

// //                           <div
// //                             className={`rounded-lg p-2 ${
// //                               isCurrentUser
// //                                 ? "bg-purple-600 text-white rounded-tr-none"
// //                                 : isAdmin
// //                                 ? "bg-green-100 text-green-900 rounded-tl-none"
// //                                 : "bg-gray-200 text-gray-800 rounded-tl-none"
// //                             }`}
// //                           >
// //                             {comment.message && comment.message.trim() && (
// //                               <div
// //                                 className="prose max-w-none break-words overflow-x-auto p-1 ql-editor custom-quill-content"
// //                                 style={{
// //                                   "--tw-prose-links": "#2563eb",
// //                                 }}
// //                                 dangerouslySetInnerHTML={createMarkup(
// //                                   comment.message
// //                                 )}
// //                               ></div>
// //                             )}

// //                             {(!comment.message || !comment.message.trim()) &&
// //                               (comment.file_urls?.length > 0 ||
// //                                 comment.file_attachments?.length > 0) && (
// //                                 <div className="text-sm font-medium mb-2">
// //                                   {comment.file_attachments?.length ||
// //                                     comment.file_urls?.length}{" "}
// //                                   file(s)
// //                                 </div>
// //                               )}

// //                             {((comment.file_urls &&
// //                               comment.file_urls.length > 0) ||
// //                               (comment.file_attachments &&
// //                                 comment.file_attachments.length > 0)) && (
// //                               <div className="mt-2 space-y-2">
// //                                 {(
// //                                   comment.file_attachments ||
// //                                   comment.file_urls.map((url, i) => ({
// //                                     url,
// //                                     name: null,
// //                                   }))
// //                                 ).map((attachment, fileIndex) => {
// //                                   const fileUrl = attachment.url || attachment;
// //                                   const rawFileName = fileUrl.split("/").pop();
// //                                   const cleanedFileName =
// //                                     attachment.name ||
// //                                     extractFileName(rawFileName);
// //                                   const parts = fileUrl.split("/").slice(3);
// //                                   let path = "/" + parts.join("/");
// //                                   path = path.replace(/\/backend/g, "");

// //                                   const isImage =
// //                                     /\.(jpe?g|png|gif|bmp|webp)$/i.test(
// //                                       cleanedFileName
// //                                     );

// //                                   return (
// //                                     <div key={fileIndex}>
// //                                       {isImage ? (
// //                                         <a
// //                                           href={`${process.env.REACT_APP_BASE_URL}${path}`}
// //                                           target="_blank"
// //                                           rel="noopener noreferrer"
// //                                           className="block mt-2"
// //                                         >
// //                                           <img
// //                                             src={`${process.env.REACT_APP_BASE_URL}${path}`}
// //                                             alt={cleanedFileName}
// //                                             className="max-h-48 rounded border border-gray-300 object-contain bg-white"
// //                                             onError={(e) => {
// //                                               console.error(
// //                                                 "Image load error:",
// //                                                 e.target.src
// //                                               );
// //                                               e.target.style.display = "none";
// //                                             }}
// //                                           />
// //                                         </a>
// //                                       ) : (
// //                                         <button
// //                                           onClick={() =>
// //                                             forceDownload(
// //                                               `${process.env.REACT_APP_BASE_URL}${path}`,
// //                                               cleanedFileName
// //                                             )
// //                                           }
// //                                           className={`flex items-center space-x-2 p-2 rounded ${
// //                                             isCurrentUser
// //                                               ? "bg-purple-700 text-purple-100"
// //                                               : "bg-white text-gray-800"
// //                                           } shadow-sm hover:opacity-80 transition-opacity`}
// //                                         >
// //                                           <span className="flex-shrink-0">
// //                                             {getFileIcon(cleanedFileName)}
// //                                           </span>
// //                                           <span className="text-sm truncate">
// //                                             {cleanedFileName}
// //                                           </span>
// //                                         </button>
// //                                       )}
// //                                     </div>
// //                                   );
// //                                 })}
// //                               </div>
// //                             )}
// //                           </div>

// //                           <span
// //                             className={`text-xs text-gray-500 mt-1 ${
// //                               isCurrentUser ? "text-right" : "text-left"
// //                             }`}
// //                           >
// //                             {new Date(comment.date_sent).toLocaleTimeString(
// //                               [],
// //                               {
// //                                 hour: "2-digit",
// //                                 minute: "2-digit",
// //                               }
// //                             )}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             )
// //           )
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default Comments;
// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";

// import {
//   getPostFinalizedData,
//   getStudentDetails,
// } from "../../services/admin.services";
// import docxImageUrl from "../../assets/docx.png";
// import pdfImageUrl from "../../assets/pdf.jpg";
// import {
//   IconPhoto,
//   IconSend,
//   IconPaperclip,
//   IconReload,
//   IconAlertCircle,
// } from "@tabler/icons-react";
// import {
//   setSocketDetails,
//   setUserDetails,
// } from "../../state/reducers/userSlice";

// const Comments = ({ activeTab }) => {
//   const location = useLocation();
//   const studentDetails = useSelector((state) => state.user.userDetails);
//   const [comment, setComment] = useState("");
//   const [comments, setComments] = useState({});
//   const [processedMessageIds, setProcessedMessageIds] = useState(new Set());
//   const [currentRoom, setCurrentRoom] = useState("");
//   const [socket, setSocket] = useState(null);
//   const [assignedAdmins, setAssignedAdmins] = useState([]);
//   const [files, setFiles] = useState([]);
//   const user_id = useSelector((state) => state.user.user_id);
//   const username = useSelector((state) => state.user.username || "");
//   const first_name = useSelector((state) => state.user.first_name || "");
//   const last_name = useSelector((state) => state.user.last_name || "");
//   const [mentionPosition, setMentionPosition] = useState(null);
//   const [mentionSuggestions, setMentionSuggestions] = useState([]);
//   const [loading, SetLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [profilePicCache, setProfilePicCache] = useState({});
//   const [uploadProgress, setUploadProgress] = useState(null);

//   // ✅ NEW: Track pending messages by client_message_id
//   const [pendingMessages, setPendingMessages] = useState(new Map());
//   const [failedMessages, setFailedMessages] = useState(new Map());

//   const dispatch = useDispatch();
//   const fileInputRef = useRef(null);
//   const messagesContainerRef = useRef(null);
//   const userProfile = useSelector((state) => state.user.profile || {});

//   const toAttachments = (urls = [], fallbackNames = []) =>
//     urls.map((u, i) => ({
//       url: u,
//       name:
//         fallbackNames[i] || extractFileName(String(u).split("/").pop() || ""),
//     }));

//   const normalizeFilePath = (path) => {
//     if (!path) return null;

//     let normalizedPath = path.replace(/\\/g, "/").replace(/%5C/g, "/");

//     if (
//       normalizedPath.startsWith("http://") ||
//       normalizedPath.startsWith("https://")
//     ) {
//       return normalizedPath;
//     }

//     if (normalizedPath.startsWith("/media")) {
//       return `${process.env.REACT_APP_BASE_URL}${normalizedPath}`;
//     }

//     if (!normalizedPath.startsWith("/")) {
//       return `${process.env.REACT_APP_BASE_URL}/media/${normalizedPath}`;
//     }

//     return normalizedPath;
//   };

//   const fixEncodedBackslashes = (url) => {
//     if (!url) return null;
//     return url.replace(/%5C/g, "/");
//   };

//   // ✅ NEW: Generate unique client message ID
//   const generateClientMessageId = () => {
//     return `${user_id}_${Date.now()}_${Math.random()
//       .toString(36)
//       .substr(2, 9)}`;
//   };

//   const fetchAdminProfile = (adminId) => {
//     if (!adminId || profilePicCache[adminId]) return;

//     console.log(`Fetching admin profile for ID: ${adminId}`);

//     fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${adminId}/`, {
//       method: "GET",
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     })
//       .then((response) => {
//         if (!response.ok) throw new Error("Admin profile fetch failed");
//         return response.json();
//       })
//       .then((data) => {
//         console.log(`Admin profile fetched for ID ${adminId}:`, data);
//         if (data && data.profile_picture_url) {
//           setProfilePicCache((prev) => ({
//             ...prev,
//             [adminId]: data.profile_picture_url,
//           }));
//           console.log(
//             `Cached admin profile pic for ${adminId}:`,
//             data.profile_picture_url
//           );
//         }
//       })
//       .catch((error) => {
//         console.error(`Error fetching admin profile for ID ${adminId}:`, error);
//       });
//   };

//   useEffect(() => {
//     const savedCache = localStorage.getItem("profilePicCache");
//     if (savedCache) {
//       try {
//         const parsedCache = JSON.parse(savedCache);
//         setProfilePicCache(parsedCache);
//         console.log("Loaded profile pic cache from localStorage:", parsedCache);
//       } catch (e) {
//         console.error("Error parsing saved profile pic cache:", e);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (Object.keys(profilePicCache).length > 0) {
//       localStorage.setItem("profilePicCache", JSON.stringify(profilePicCache));
//       console.log("Saved profile pic cache to localStorage");
//     }
//   }, [profilePicCache]);

//   useEffect(() => {
//     if (user_id && userProfile?.profile_picture_url) {
//       const normalizedPic = normalizeFilePath(userProfile.profile_picture_url);
//       setProfilePicCache((prev) => ({
//         ...prev,
//         [user_id]: normalizedPic,
//       }));
//       console.log("Directly added user profile to cache:", normalizedPic);
//     }
//   }, [user_id, userProfile?.profile_picture_url]);

//   const logMessageData = (message) => {
//     console.log("Message data:", {
//       sender: message.sender_id,
//       username: message.sender_username,
//       profilePic: message.sender_profile_pic,
//       content:
//         message.message?.substring(0, 20) +
//         (message.message?.length > 20 ? "..." : ""),
//     });
//   };

//   const getInitialsAvatar = (firstName, lastName, username) => {
//     if (firstName && firstName.length > 0 && lastName && lastName.length > 0) {
//       return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
//     }

//     if (firstName && firstName.length > 0) {
//       return `${firstName.charAt(0)}${
//         firstName.length > 1 ? firstName.charAt(1) : ""
//       }`.toUpperCase();
//     }

//     if (lastName && lastName.length > 0) {
//       return `${lastName.charAt(0)}${
//         lastName.length > 1 ? lastName.charAt(1) : ""
//       }`.toUpperCase();
//     }

//     if (username) {
//       const parts = username.split(/[\s_.-]/);
//       if (parts.length > 1) {
//         return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(
//           0
//         )}`.toUpperCase();
//       }
//       if (username.length > 1) {
//         return `${username.charAt(0)}${username.charAt(
//           username.length - 1
//         )}`.toUpperCase();
//       }
//       if (username.length === 1) {
//         return `${username.charAt(0)}S`.toUpperCase();
//       }
//     }

//     return "ST";
//   };

//   const getAvatarColor = (initials) => {
//     const hash = initials
//       .split("")
//       .reduce((acc, char) => acc + char.charCodeAt(0), 0);

//     const colors = [
//       "#1E88E5",
//       "#43A047",
//       "#E53935",
//       "#FB8C00",
//       "#8E24AA",
//       "#00ACC1",
//       "#3949AB",
//       "#00897B",
//       "#7CB342",
//       "#C0CA33",
//       "#FFB300",
//       "#F4511E",
//       "#6D4C41",
//       "#757575",
//       "#546E7A",
//     ];

//     return colors[hash % colors.length];
//   };

//   const generateAvatar = (
//     firstName,
//     lastName,
//     username,
//     profilePic,
//     userId,
//     size = "small"
//   ) => {
//     if (userId && profilePicCache[userId]) {
//       profilePic = profilePicCache[userId];
//     }

//     if (profilePic) {
//       const normalizedProfilePic = normalizeFilePath(profilePic);
//       const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

//       return (
//         <div
//           className={`${sizeClass} rounded-full overflow-hidden border-2 border-white shadow-md`}
//         >
//           <img
//             src={normalizedProfilePic}
//             alt={`${firstName || username}'s avatar`}
//             className="w-full h-full object-cover"
//             onLoad={() => {
//               if (userId) {
//                 setProfilePicCache((prev) => ({
//                   ...prev,
//                   [userId]: normalizedProfilePic,
//                 }));
//               }
//             }}
//             onError={(e) => {
//               const pathParts = normalizedProfilePic.split("/");
//               const filename = pathParts[pathParts.length - 1];
//               const altPath = `${process.env.REACT_APP_BASE_URL}/media/profile_pictures/${filename}`;

//               if (normalizedProfilePic !== altPath) {
//                 e.target.src = altPath;
//                 e.target.onerror = (secondError) => {
//                   secondError.target.style.display = "none";
//                   secondError.target.parentNode.innerHTML = `
//                     <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
//                       style="background-color: ${getAvatarColor(
//                         getInitialsAvatar(firstName, lastName, username)
//                       )}">
//                       ${getInitialsAvatar(firstName, lastName, username)}
//                     </div>
//                   `;
//                 };
//               } else {
//                 e.target.style.display = "none";
//                 e.target.parentNode.innerHTML = `
//                   <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
//                     style="background-color: ${getAvatarColor(
//                       getInitialsAvatar(firstName, lastName, username)
//                     )}">
//                     ${getInitialsAvatar(firstName, lastName, username)}
//                   </div>
//                 `;
//               }
//             }}
//           />
//         </div>
//       );
//     }

//     const initials = getInitialsAvatar(firstName, lastName, username);
//     const backgroundColor = getAvatarColor(initials);
//     const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

//     return (
//       <div
//         className={`flex items-center justify-center rounded-full ${sizeClass} text-white font-medium`}
//         style={{ backgroundColor }}
//       >
//         {initials}
//       </div>
//     );
//   };

//   const generateMessageId = (message) => {
//     const timestamp = message.date_sent || message.timestamp;
//     const fileInfo =
//       message.file_urls && message.file_urls.length > 0
//         ? message.file_urls
//             .map((f) => (typeof f === "object" ? f.name : f))
//             .join(",")
//         : "";

//     return `${message.sender_id}_${timestamp}_${
//       message.message || ""
//     }_${fileInfo}`.replace(/\s/g, "");
//   };

//   const fetchUniversities = async (query) => {
//     try {
//       const response = await getPostFinalizedData();

//       if (!response.data || !Array.isArray(response.data.universities)) {
//         setMentionSuggestions([]);
//         return;
//       }

//       const universities = response.data.universities;

//       if (universities.length > 0) {
//         const filteredUniversities = universities.filter(
//           (uni) =>
//             uni.university_name &&
//             uni.university_name.toLowerCase().includes(query.toLowerCase())
//         );

//         setMentionSuggestions(filteredUniversities);
//       } else {
//         setMentionSuggestions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching universities:", error);
//       setMentionSuggestions([]);
//     }
//   };

//   // ✅ UPDATED: WebSocket with proper message handling
//   useEffect(() => {
//     const pathParts = location.pathname.split("/");
//     const roomName = pathParts[pathParts.length - 1] || "default_room";

//     if (!user_id) {
//       console.error("User ID is required for WebSocket connection");
//       return;
//     }

//     setCurrentRoom(roomName);

//     const socketURL = `${process.env.REACT_APP_WEB_SOCKET_URL}/${roomName}/${user_id}/`;
//     console.log(`Connecting to WebSocket: ${socketURL}`);

//     if (socket) {
//       console.log("Closing previous WebSocket connection");
//       socket.close();
//     }

//     setProcessedMessageIds(new Set());

//     const newSocket = new WebSocket(socketURL);
//     setSocket(newSocket);
//     dispatch(setSocketDetails(newSocket));

//     newSocket.onopen = () => {
//       console.log("WebSocket connection established");
//     };

//     newSocket.onerror = (error) => {
//       console.error("WebSocket error:", error);
//     };

//     newSocket.onclose = (event) => {
//       console.log("WebSocket connection closed:", event);
//     };

//     newSocket.onmessage = (event) => {
//       const data = JSON.parse(event.data);

//       if (data.error) {
//         console.error("WebSocket error:", data.error);
//         return;
//       }

//       const { message_id, client_message_id } = data;

//       // ✅ Clear pending message when confirmed
//       if (client_message_id) {
//         console.log("✅ Clearing pending message:", client_message_id);
//         setPendingMessages((prev) => {
//           const newMap = new Map(prev);
//           newMap.delete(client_message_id);
//           return newMap;
//         });
//       }

//       const messageId = message_id || generateMessageId(data);

//       if (processedMessageIds.has(messageId)) {
//         console.log("⚠️ Skipping duplicate message:", messageId);
//         return;
//       }

//       setProcessedMessageIds((prev) => {
//         const newSet = new Set([...prev, messageId]);
//         return newSet;
//       });

//       setComments((prev) => {
//         const existingComments = prev[roomName] || [];

//         // ✅ Check for duplicate by message_id
//         if (existingComments.some((msg) => msg.message_id === messageId)) {
//           console.log("⚠️ Skipping duplicate message_id:", messageId);
//           return prev;
//         }

//         // ✅ Check for duplicate by client_message_id
//         if (
//           client_message_id &&
//           existingComments.some(
//             (msg) =>
//               msg.client_message_id === client_message_id && msg.isDelivered
//           )
//         ) {
//           console.log(
//             "⚠️ Skipping duplicate client_message_id:",
//             client_message_id
//           );
//           return prev;
//         }

//         // ✅ Find and REPLACE pending message
//         let pendingIndex = -1;
//         if (client_message_id) {
//           pendingIndex = existingComments.findIndex(
//             (msg) =>
//               msg.client_message_id === client_message_id && msg.isPending
//           );
//         }

//         let updatedComments;
//         if (pendingIndex !== -1) {
//           console.log("🔄 REPLACING pending message at index:", pendingIndex);
//           updatedComments = [...existingComments];
//           updatedComments[pendingIndex] = {
//             ...data,
//             message_id: messageId,
//             isDelivered: true,
//             isPending: false,
//             isFailed: false,
//           };
//         } else {
//           console.log("➕ Adding new message");
//           updatedComments = [
//             ...existingComments,
//             {
//               ...data,
//               message_id: messageId,
//               isDelivered: true,
//               isPending: false,
//               isFailed: false,
//             },
//           ];
//         }

//         updatedComments.sort(
//           (a, b) => new Date(a.date_sent) - new Date(b.date_sent)
//         );

//         return {
//           ...prev,
//           [roomName]: updatedComments,
//         };
//       });
//     };

//     return () => {
//       console.log("Cleaning up WebSocket connection");
//       if (
//         newSocket &&
//         (newSocket.readyState === WebSocket.OPEN ||
//           newSocket.readyState === WebSocket.CONNECTING)
//       ) {
//         newSocket.close();
//       }
//     };
//   }, [location.pathname, user_id]);

//   useEffect(() => {
//     if (currentRoom && user_id) {
//       fetch(
//         `${process.env.REACT_APP_BASE_URL}/chat_app/api/message-history/${currentRoom}/`
//       )
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//           }
//           return response.json();
//         })
//         .then((data) => {
//           if (data.messages && Array.isArray(data.messages)) {
//             const uniqueMessages = [];
//             const uniqueMessageIds = new Set([...processedMessageIds]);
//             const tempProfileCache = { ...profilePicCache };

//             data.messages.forEach((message) => {
//               if (message.sender_profile_pic) {
//                 if (message.sender_id) {
//                   tempProfileCache[message.sender_id] =
//                     message.sender_profile_pic;
//                 }
//               }

//               const messageId = generateMessageId(message);
//               if (!uniqueMessageIds.has(messageId)) {
//                 uniqueMessageIds.add(messageId);
//                 uniqueMessages.push({
//                   ...message,
//                   isDelivered: true,
//                   isPending: false,
//                   isFailed: false,
//                 });
//               }
//             });

//             setProfilePicCache(tempProfileCache);
//             setProcessedMessageIds(uniqueMessageIds);

//             setComments((prev) => {
//               const existingComments = prev[currentRoom] || [];
//               const combinedComments = [...existingComments, ...uniqueMessages];

//               combinedComments.sort(
//                 (a, b) => new Date(a.date_sent) - new Date(b.date_sent)
//               );

//               return {
//                 ...prev,
//                 [currentRoom]: combinedComments,
//               };
//             });
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching message history:", error);
//         });
//     }
//   }, [currentRoom, user_id]);

//   useEffect(() => {
//     if (studentDetails) {
//       setAssignedAdmins(studentDetails.assigned_admins);
//     }
//   }, [studentDetails]);

//   const handleCommentChange = (e) => {
//     const value = e.target.value;
//     setComment(value);

//     const cursorPosition = e.target.selectionStart;
//     setMentionPosition(cursorPosition);

//     const words = value.substring(0, cursorPosition).split(/\s+/);
//     const lastWord = words[words.length - 1];

//     if (lastWord.startsWith("@")) {
//       const searchQuery = lastWord.substring(1);
//       if (searchQuery.length > 0) {
//         fetchUniversities(searchQuery);
//       } else {
//         setMentionSuggestions([]);
//       }
//     } else {
//       setMentionSuggestions([]);
//     }
//   };

//   useEffect(() => {
//     const savedProcessedIds = localStorage.getItem(
//       `processedMessageIds_${user_id}`
//     );
//     if (savedProcessedIds) {
//       try {
//         const parsedIds = JSON.parse(savedProcessedIds);
//         setProcessedMessageIds(new Set(parsedIds));
//         console.log(
//           "Loaded processed message IDs from localStorage:",
//           parsedIds.length
//         );
//       } catch (e) {
//         console.error("Error parsing saved processed message IDs:", e);
//       }
//     }
//   }, [user_id]);

//   useEffect(() => {
//     if (processedMessageIds.size > 0) {
//       const idsArray = Array.from(processedMessageIds);
//       localStorage.setItem(
//         `processedMessageIds_${user_id}`,
//         JSON.stringify(idsArray)
//       );
//       console.log("Saved processed message IDs to localStorage");
//     }
//   }, [processedMessageIds, user_id]);

//   const handleSelectUniversity = (university) => {
//     const words = comment.substring(0, mentionPosition).split(/\s+/);
//     words[words.length - 1] = `@${university.university_name} `;
//     const updatedComment = words.join(" ") + comment.substring(mentionPosition);

//     setComment(updatedComment);
//     setMentionSuggestions([]);
//   };

//   const renderCommentWithMentions = (text) => {
//     if (!text) return "";

//     const mentionRegex = /(@[a-zA-Z0-9\s]+)/g;
//     return text.split(mentionRegex).map((part, index) => {
//       if (part.startsWith("@")) {
//         return (
//           <span
//             key={index}
//             className="text-white bg-blue-50 rounded px-1 font-semibold cursor-pointer"
//           >
//             {part}
//           </span>
//         );
//       }
//       return part;
//     });
//   };

//   const handleFileChange = (e) => {
//     const selectedFiles = Array.from(e.target.files);
//     setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
//   };

//   const handleRemoveFile = (indexToRemove) => {
//     setFiles((prevFiles) =>
//       prevFiles.filter((_, index) => index !== indexToRemove)
//     );
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handlePostClick();
//     }
//   };

//   const getFileIcon = (fileName) => {
//     if (fileName) {
//       const ext = fileName.split(".").pop().toLowerCase();
//       if (["jpg", "jpeg", "png", "gif"].includes(ext))
//         return <IconPhoto size={20} />;
//       if (["pdf"].includes(ext))
//         return <img src={pdfImageUrl} alt="PDF Icon" width="24" height="24" />;
//       if (["doc", "docx"].includes(ext))
//         return (
//           <img src={docxImageUrl} alt="DOCX Icon" width="24" height="24" />
//         );
//       return "📁";
//     }
//   };

//   // ✅ UPDATED: Handle file upload with proper error handling
//   const handlePostClick = () => {
//     if (!socket || (!comment.trim() && files.length === 0)) {
//       alert("Cannot send an empty comment or file.");
//       return;
//     }

//     if (!assignedAdmins) {
//       alert("Assigned admins data is missing. Please try again later.");
//       return;
//     }

//     const clientMessageId = generateClientMessageId();
//     console.log("📤 Sending message with client_message_id:", clientMessageId);

//     setIsLoading(true);
//     setUploadProgress(0);

//     // ✅ Create optimistic message
//     const optimisticMessage = {
//       message: comment.trim() || files.map((f) => f.name).join(", "),
//       sender_id: user_id,
//       sender_username: username || "You",
//       first_name,
//       last_name,
//       sender_role: "student",
//       sender_profile_pic:
//         userProfile?.profile_picture_url || profilePicCache[user_id] || null,
//       date_sent: new Date().toISOString(),
//       client_message_id: clientMessageId,
//       isPending: true,
//       isFailed: false,
//       isDelivered: false,
//       file_urls: files.length > 0 ? ["pending"] : [],
//     };

//     setComments((prev) => {
//       const roomComments = prev[currentRoom] || [];
//       return {
//         ...prev,
//         [currentRoom]: [...roomComments, optimisticMessage],
//       };
//     });

//     setPendingMessages((prev) =>
//       new Map(prev).set(clientMessageId, {
//         originalMessage: comment,
//         originalFiles: files,
//         timestamp: Date.now(),
//       })
//     );

//     const formData = new FormData();

//     files.forEach((file) => {
//       formData.append(`file`, file);
//     });

//     const plainMessage = comment.replace(/<[^>]*>/g, "").trim();
//     if (!plainMessage && files.length > 0) {
//       const fileNames = files.map((f) => f.name).join(", ");
//       formData.append("message", fileNames);
//     } else if (plainMessage) {
//       formData.append("message", plainMessage);
//     }

//     formData.append("roomname", currentRoom);
//     formData.append("sender_id", user_id);
//     formData.append("first_name", first_name || username.split(" ")[0] || "S");
//     formData.append("last_name", last_name || username.split(" ")[1] || "T");
//     formData.append("client_message_id", clientMessageId);

//     let receiverId;
//     if (
//       currentRoom === "cv_upload" ||
//       currentRoom === "sop" ||
//       currentRoom === "lor" ||
//       currentRoom === "university_specific_sop" ||
//       currentRoom === "ug_only" ||
//       currentRoom === "final_documents_upload"
//     ) {
//       receiverId = assignedAdmins.assigned_content_writer?.id;
//     } else if (currentRoom === "shortlisting_of_universities") {
//       receiverId = assignedAdmins.assigned_to?.id;
//     } else if (currentRoom === "university_application_process") {
//       receiverId = assignedAdmins.assigned_application_manager?.id;
//     } else if (currentRoom === "visa_process") {
//       receiverId = assignedAdmins.assigned_visa_manager?.id;
//     } else {
//       receiverId = assignedAdmins.assigned_to?.id;
//     }

//     if (!receiverId) {
//       alert("Receiver not found for this action. Please contact support.");
//       setIsLoading(false);
//       return;
//     }

//     formData.append("receiver_id", receiverId);

//     // Clear form BEFORE sending
//     const originalComment = comment;
//     const originalFiles = [...files];
//     setComment("");
//     setFiles([]);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }

//     fetch(`${process.env.REACT_APP_BASE_URL}/chat_app/api/upload/`, {
//       method: "POST",
//       body: formData,
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     })
//       .then((response) => {
//         setIsLoading(false);
//         setUploadProgress(null);

//         if (!response.ok) {
//           throw new Error("Failed to upload message. Please try again.");
//         }
//         return response.json();
//       })
//       .then((data) => {
//         console.log("✅ Upload success:", data);
//         // WebSocket will handle adding the confirmed message
//       })
//       .catch((error) => {
//         console.error("❌ Upload error:", error);
//         setIsLoading(false);
//         setUploadProgress(null);

//         // Mark as failed
//         setPendingMessages((prev) => {
//           const newMap = new Map(prev);
//           newMap.delete(clientMessageId);
//           return newMap;
//         });

//         setFailedMessages((prev) =>
//           new Map(prev).set(clientMessageId, {
//             originalMessage: originalComment,
//             originalFiles,
//           })
//         );

//         setComments((prev) => {
//           const roomComments = prev[currentRoom] || [];
//           return {
//             ...prev,
//             [currentRoom]: roomComments.map((msg) =>
//               msg.client_message_id === clientMessageId
//                 ? { ...msg, isPending: false, isFailed: true }
//                 : msg
//             ),
//           };
//         });
//       });
//   };

//   // ✅ NEW: Retry failed message
//   const retryFailedMessage = (clientMessageId) => {
//     const failedData = failedMessages.get(clientMessageId);
//     if (!failedData) return;

//     setFailedMessages((prev) => {
//       const newMap = new Map(prev);
//       newMap.delete(clientMessageId);
//       return newMap;
//     });

//     setComments((prev) => {
//       const roomComments = prev[currentRoom] || [];
//       return {
//         ...prev,
//         [currentRoom]: roomComments.filter(
//           (msg) => msg.client_message_id !== clientMessageId
//         ),
//       };
//     });

//     setComment(failedData.originalMessage);
//     setFiles(failedData.originalFiles);

//     setTimeout(() => handlePostClick(), 100);
//   };

//   // ✅ NEW: Timeout for pending messages
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const now = Date.now();

//       pendingMessages.forEach((data, id) => {
//         if (now - data.timestamp > 15000) {
//           console.warn("⚠️ Timeout:", id);

//           setPendingMessages((prev) => {
//             const newMap = new Map(prev);
//             newMap.delete(id);
//             return newMap;
//           });

//           setComments((prev) => {
//             const roomComments = prev[currentRoom] || [];
//             return {
//               ...prev,
//               [currentRoom]: roomComments.map((msg) =>
//                 msg.client_message_id === id
//                   ? { ...msg, isPending: false, isFailed: true }
//                   : msg
//               ),
//             };
//           });

//           setFailedMessages((prev) => new Map(prev).set(id, data));
//         }
//       });
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [pendingMessages, currentRoom]);

//   const extractFileName = (fileName) => {
//     const decodedName = decodeURIComponent(fileName);
//     return decodedName.replace(/^[a-f0-9]{32,}_/, "");
//   };

//   const groupMessagesByDate = (messages) => {
//     if (!messages || messages.length === 0) return {};

//     const grouped = messages.reduce((groups, message) => {
//       const date = new Date(message.date_sent);
//       const dateKey = date.toLocaleDateString("en-US", {
//         weekday: "short",
//         month: "short",
//         day: "numeric",
//       });

//       if (!groups[dateKey]) {
//         groups[dateKey] = [];
//       }

//       groups[dateKey].push(message);
//       return groups;
//     }, {});

//     const reversedEntries = Object.entries(grouped).reverse();
//     const result = {};
//     reversedEntries.forEach(([key, msgs]) => {
//       result[key] = msgs.reverse();
//     });

//     return result;
//   };

//   const forceDownload = (url, filename) => {
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = filename;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const getStudentProfile = async (user_id) => {
//     try {
//       SetLoading(true);
//       const res = await getStudentDetails(user_id);
//       dispatch(setUserDetails(res.data));
//     } catch (err) {
//       console.log(err);
//     } finally {
//       SetLoading(false);
//     }
//   };

//   return (
//     <>
//       {/* ✅ FULL-PAGE LOADING OVERLAY */}
//       {isLoading && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center">
//           <div className="bg-white rounded-lg p-8 shadow-2xl flex flex-col items-center max-w-md">
//             <svg
//               className="animate-spin h-16 w-16 text-purple-600 mb-4"
//               viewBox="0 0 24 24"
//             >
//               <circle
//                 className="opacity-25"
//                 cx="12"
//                 cy="12"
//                 r="10"
//                 stroke="currentColor"
//                 strokeWidth="4"
//                 fill="none"
//               />
//               <path
//                 className="opacity-75"
//                 fill="currentColor"
//                 d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//               />
//             </svg>
//             <p className="text-xl font-semibold text-gray-800 mb-2">
//               {uploadProgress !== null
//                 ? `Uploading file...`
//                 : "Sending message..."}
//             </p>
//             {uploadProgress !== null && (
//               <div className="w-full mt-4">
//                 <div className="w-full bg-gray-200 rounded-full h-4">
//                   <div
//                     className="bg-purple-600 h-4 rounded-full transition-all duration-300"
//                     style={{ width: `${uploadProgress}%` }}
//                   />
//                 </div>
//                 <p className="text-center text-sm text-gray-600 mt-2">
//                   {uploadProgress}%
//                 </p>
//               </div>
//             )}
//             <p className="text-sm text-gray-500 mt-4 text-center">
//               Please wait, do not close or refresh the page
//             </p>
//           </div>
//         </div>
//       )}

//       <div className="flex flex-col h-full bg-gray-50 rounded-lg shadow-md overflow-hidden max-w-7xl w-full select-text">
//         <div className="flex justify-between items-center bg-purple-700 text-white p-4">
//           <h3 className="text-lg font-semibold">Comments</h3>
//           <button
//             className="shadow-md p-2 bg-purple-500 rounded-full text-white transition-transform active:scale-95 disabled:opacity-50"
//             onClick={() => getStudentProfile(user_id)}
//             disabled={loading}
//           >
//             {loading ? (
//               <IconReload className="animate-spin" size={20} />
//             ) : (
//               <IconReload size={20} />
//             )}
//           </button>
//         </div>

//         <div className="bg-white p-4 border-t border-gray-200 shadow-sm">
//           <div className="flex items-start">
//             {generateAvatar(
//               first_name,
//               last_name,
//               username,
//               studentDetails?.profile_picture_url || null,
//               user_id
//             )}
//             <div className="flex-grow mx-3 relative">
//               <textarea
//                 value={comment}
//                 onChange={handleCommentChange}
//                 onKeyDown={handleKeyDown}
//                 placeholder="Write a message..."
//                 className="w-full border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 rounded-lg resize-none"
//                 rows="2"
//               ></textarea>
//               {mentionSuggestions.length > 0 && (
//                 <ul className="absolute bg-white border border-gray-300 shadow-lg list-none p-0 mt-1 max-h-48 overflow-y-auto w-full rounded-md z-10">
//                   {mentionSuggestions.map((university) => (
//                     <li
//                       key={university.id}
//                       onClick={() => handleSelectUniversity(university)}
//                       className="p-2 cursor-pointer hover:bg-gray-100"
//                     >
//                       {university.university_name}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//               {files.length > 0 && (
//                 <div className="mt-2 space-y-2">
//                   {files.map((file, index) => (
//                     <div
//                       key={index}
//                       className="p-2 bg-gray-100 rounded-md flex items-center"
//                     >
//                       <span className="mr-2">{getFileIcon(file.name)}</span>
//                       <span className="text-sm font-medium truncate flex-1">
//                         {file.name}
//                       </span>
//                       <button
//                         onClick={() => handleRemoveFile(index)}
//                         className="ml-2 text-gray-500 hover:text-red-500 flex-shrink-0"
//                       >
//                         ✕
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <div className="flex space-x-2">
//               <label className="cursor-pointer p-2 bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 flex items-center justify-center w-10 h-10 transition-colors">
//                 <IconPaperclip size={20} />
//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   onChange={handleFileChange}
//                   className="hidden"
//                   multiple
//                 />
//               </label>
//               <button
//                 onClick={handlePostClick}
//                 disabled={isLoading}
//                 className="bg-purple-600 text-white p-2 rounded-full hover:bg-purple-700 transition-colors flex items-center justify-center w-10 h-10 disabled:opacity-50"
//               >
//                 <IconSend size={20} />
//               </button>
//             </div>
//           </div>
//         </div>

//         <div
//           ref={messagesContainerRef}
//           className="flex-grow overflow-y-auto p-4 flex flex-col space-y-4"
//           style={{ maxHeight: "calc(100vh - 250px)" }}
//         >
//           {!comments[currentRoom] || comments[currentRoom].length === 0 ? (
//             <div className="flex items-center justify-center h-full">
//               <p className="text-gray-500 italic">
//                 No messages yet. Start the conversation!
//               </p>
//             </div>
//           ) : (
//             Object.entries(groupMessagesByDate(comments[currentRoom])).map(
//               ([dateKey, messagesGroup], groupIndex) => (
//                 <div key={`group-${groupIndex}`}>
//                   <div className="flex justify-center my-3">
//                     <div className="px-4 py-1 rounded-full bg-gray-200 text-xs text-gray-600">
//                       {dateKey}
//                     </div>
//                   </div>

//                   {messagesGroup.map((comment, index) => {
//                     const isCurrentUser = comment.sender_id === user_id;
//                     const isAdmin =
//                       comment.sender_role === "admin" || comment.is_admin;
//                     const isConsecutive =
//                       index > 0 &&
//                       comment.sender_id === messagesGroup[index - 1].sender_id;

//                     const isPending = comment.isPending;
//                     const isFailed = comment.isFailed;

//                     const linkifyMessage = (message, isCurrentUser) => {
//                       if (!message) return "";

//                       const urlRegex =
//                         /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

//                       return message.replace(urlRegex, (match) => {
//                         const url = match.startsWith("http")
//                           ? match
//                           : `https://${match}`;
//                         const linkColorClass = isCurrentUser
//                           ? "text-white underline cursor-pointer"
//                           : "text-blue-700 underline hover:text-blue-900 cursor-pointer";

//                         return `<a href="${url}" class="${linkColorClass} break-words" target="_blank" rel="noopener noreferrer">${match}</a>`;
//                       });
//                     };

//                     const sanitizeAndLinkifyMessage = (
//                       message,
//                       isCurrentUser
//                     ) => {
//                       if (!message) return "";

//                       const textOnly = message.replace(
//                         /<a[^>]*>(.*?)<\/a>/gi,
//                         "$1"
//                       );

//                       const urlRegex =
//                         /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

//                       return textOnly.replace(urlRegex, (match) => {
//                         const url = match.startsWith("http")
//                           ? match
//                           : `https://${match}`;
//                         const linkColor = isCurrentUser ? "#fff" : "#2563eb";
//                         return `<a href="${url}" target="_blank" rel="noopener noreferrer"
//                 style="color:${linkColor}; text-decoration:underline;">${match}</a>`;
//                       });
//                     };

//                     const createMarkup = (msg) => {
//                       const hasAnchorTag = /<a\s+[^>]*href=/i.test(msg);
//                       if (hasAnchorTag) {
//                         return {
//                           __html: sanitizeAndLinkifyMessage(msg, isCurrentUser),
//                         };
//                       } else {
//                         return { __html: linkifyMessage(msg, isCurrentUser) };
//                       }
//                     };

//                     return (
//                       <div
//                         key={`comment-${index}-${generateMessageId(comment)}`}
//                       >
//                         <div
//                           className={`flex items-start gap-2 ${
//                             isCurrentUser ? "flex-row-reverse" : "flex-row"
//                           }`}
//                         >
//                           {!isConsecutive ? (
//                             <div className="flex-shrink-0">
//                               {isCurrentUser
//                                 ? generateAvatar(
//                                     first_name,
//                                     last_name,
//                                     username,
//                                     userProfile?.profile_picture_url ||
//                                       profilePicCache[user_id] ||
//                                       null,
//                                     user_id
//                                   )
//                                 : generateAvatar(
//                                     comment.first_name,
//                                     comment.last_name,
//                                     comment.sender_username || "User",
//                                     comment.sender_profile_pic,
//                                     comment.sender_id
//                                   )}
//                             </div>
//                           ) : (
//                             <div className="w-10"></div>
//                           )}

//                           <div className="flex flex-col max-w-xs md:max-w-md">
//                             {!isConsecutive && (
//                               <span
//                                 className={`text-xs font-medium mb-1 flex items-center gap-1 ${
//                                   isCurrentUser
//                                     ? "text-right justify-end"
//                                     : "text-left"
//                                 }`}
//                               >
//                                 {isCurrentUser
//                                   ? "You"
//                                   : comment.sender_username || "User"}
//                                 {isPending && (
//                                   <span className="text-gray-400 italic ml-1">
//                                     Sending...
//                                   </span>
//                                 )}
//                               </span>
//                             )}

//                             <div
//                               className={`rounded-lg p-2 ${
//                                 isCurrentUser
//                                   ? "bg-purple-600 text-white rounded-tr-none"
//                                   : isAdmin
//                                   ? "bg-green-100 text-green-900 rounded-tl-none"
//                                   : "bg-gray-200 text-gray-800 rounded-tl-none"
//                               }`}
//                             >
//                               {comment.message && comment.message.trim() && (
//                                 <div
//                                   className="prose max-w-none break-words overflow-x-auto p-1 ql-editor custom-quill-content"
//                                   style={{
//                                     "--tw-prose-links": "#2563eb",
//                                   }}
//                                   dangerouslySetInnerHTML={createMarkup(
//                                     comment.message
//                                   )}
//                                 ></div>
//                               )}

//                               {(!comment.message || !comment.message.trim()) &&
//                                 (comment.file_urls?.length > 0 ||
//                                   comment.file_attachments?.length > 0) && (
//                                   <div className="text-sm font-medium mb-2">
//                                     {comment.file_attachments?.length ||
//                                       comment.file_urls?.length}{" "}
//                                     file(s)
//                                   </div>
//                                 )}

//                               {((comment.file_urls &&
//                                 comment.file_urls.length > 0 &&
//                                 comment.file_urls[0] !== "pending") ||
//                                 (comment.file_attachments &&
//                                   comment.file_attachments.length > 0)) && (
//                                 <div className="mt-2 space-y-2">
//                                   {(
//                                     comment.file_attachments ||
//                                     comment.file_urls.map((url, i) => ({
//                                       url,
//                                       name: null,
//                                     }))
//                                   ).map((attachment, fileIndex) => {
//                                     const fileUrl =
//                                       attachment.url || attachment;
//                                     const rawFileName = fileUrl
//                                       .split("/")
//                                       .pop();
//                                     const cleanedFileName =
//                                       attachment.name ||
//                                       extractFileName(rawFileName);
//                                     const parts = fileUrl.split("/").slice(3);
//                                     let path = "/" + parts.join("/");
//                                     path = path.replace(/\/backend/g, "");

//                                     const isImage =
//                                       /\.(jpe?g|png|gif|bmp|webp)$/i.test(
//                                         cleanedFileName
//                                       );

//                                     return (
//                                       <div key={fileIndex}>
//                                         {isImage ? (
//                                           <a
//                                             href={`${process.env.REACT_APP_BASE_URL}${path}`}
//                                             target="_blank"
//                                             rel="noopener noreferrer"
//                                             className="block mt-2"
//                                           >
//                                             <img
//                                               src={`${process.env.REACT_APP_BASE_URL}${path}`}
//                                               alt={cleanedFileName}
//                                               className="max-h-48 rounded border border-gray-300 object-contain bg-white"
//                                               onError={(e) => {
//                                                 console.error(
//                                                   "Image load error:",
//                                                   e.target.src
//                                                 );
//                                                 e.target.style.display = "none";
//                                               }}
//                                             />
//                                           </a>
//                                         ) : (
//                                           <button
//                                             onClick={() =>
//                                               forceDownload(
//                                                 `${process.env.REACT_APP_BASE_URL}${path}`,
//                                                 cleanedFileName
//                                               )
//                                             }
//                                             className={`flex items-center space-x-2 p-2 rounded ${
//                                               isCurrentUser
//                                                 ? "bg-purple-700 text-purple-100"
//                                                 : "bg-white text-gray-800"
//                                             } shadow-sm hover:opacity-80 transition-opacity`}
//                                           >
//                                             <span className="flex-shrink-0">
//                                               {getFileIcon(cleanedFileName)}
//                                             </span>
//                                             <span className="text-sm truncate">
//                                               {cleanedFileName}
//                                             </span>
//                                           </button>
//                                         )}
//                                       </div>
//                                     );
//                                   })}
//                                 </div>
//                               )}

//                               {isFailed && (
//                                 <div className="mt-2 flex items-center gap-2 text-xs">
//                                   <IconAlertCircle
//                                     size={14}
//                                     className="text-red-300"
//                                   />
//                                   <span className="text-red-300">
//                                     Failed to send
//                                   </span>
//                                   <button
//                                     onClick={() =>
//                                       retryFailedMessage(
//                                         comment.client_message_id
//                                       )
//                                     }
//                                     className="flex items-center gap-1 text-blue-300 hover:text-blue-100"
//                                   >
//                                     <IconReload size={14} />
//                                     <span>Retry</span>
//                                   </button>
//                                 </div>
//                               )}
//                             </div>

//                             <span
//                               className={`text-xs text-gray-500 mt-1 ${
//                                 isCurrentUser ? "text-right" : "text-left"
//                               }`}
//                             >
//                               {new Date(comment.date_sent).toLocaleTimeString(
//                                 [],
//                                 {
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                 }
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               )
//             )
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Comments;
// import React, { useEffect, useState, useRef } from "react";
// import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   IconSend,
//   IconPaperclip,
//   IconX,
//   IconFile,
//   IconPhoto,
// } from "@tabler/icons-react";
// import { useWebSocket } from "../../state/reducers/WebSocketProvider";
// import { getPostFinalizedData } from "../../services/admin.services";
// import docxImageUrl from "../../assets/docx.png";
// import pdfImageUrl from "../../assets/pdf.jpg";

// const genId = () => `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

// export default function Comments() {
//   const location = useLocation();
//   const fileInputRef = useRef(null);
//   const topRef = useRef(null);
//   const messagesContainerRef = useRef(null);
//   const processedIds = useRef(new Set());
//   const textareaRef = useRef(null);

//   const user = useSelector((s) => s.user);
//   const studentDetails = useSelector((s) => s.user.userDetails);

//   const userId = user?.user_id;
//   const username = user?.username;
//   const firstName = user?.first_name;
//   const lastName = user?.last_name;
//   const userRole = user?.role || "student";
//   const userPic = user?.profile?.profile_picture_url;

//   const { createConnection, closeConnection, sendMessage, getConnectionState } =
//     useWebSocket();

//   const [messages, setMessages] = useState([]);
//   const [pending, setPending] = useState({});
//   const [comment, setComment] = useState("");
//   const [loadingHistory, setLoadingHistory] = useState(false);
//   const [uploadingFiles, setUploadingFiles] = useState(false);
//   const [files, setFiles] = useState([]);

//   // ✅ University tagging states
//   const [mentionPosition, setMentionPosition] = useState(null);
//   const [mentionSuggestions, setMentionSuggestions] = useState([]);

//   // ✅ Helper function to safely get first/last name
//   const getFirstName = () => {
//     if (firstName) return firstName;
//     if (username && typeof username === "string") {
//       const parts = username.split(" ");
//       return parts[0] || "S";
//     }
//     return "S";
//   };
//   const sortMessages = (msgs) =>
//     [...msgs].sort(
//       (a, b) =>
//         new Date(a.date_sent).getTime() - new Date(b.date_sent).getTime()
//     );

//   const getLastName = () => {
//     if (lastName) return lastName;
//     if (username && typeof username === "string") {
//       const parts = username.split(" ");
//       return parts[1] || "T";
//     }
//     return "T";
//   };

//   // ✅ Extract room key from URL path
//   const getRoomKeyFromPath = () => {
//     if (!location || !location.pathname) {
//       console.warn("⚠️ Location or pathname is undefined");
//       return null;
//     }

//     const pathParts = location.pathname.split("/").filter(Boolean); // Remove empty strings
//     const lastPart = pathParts[pathParts.length - 1];

//     console.log("📍 Path parts:", pathParts, "Room key:", lastPart);

//     // Return the last part of the path (e.g., "visa_process" from "/student/visa_process")
//     return lastPart || null;
//   };

//   // ✅ Convert room key to display title
//   const getRoomTitle = (roomKey) => {
//     if (!roomKey) return "Comments";

//     // Convert snake_case to Title Case
//     return roomKey
//       .split("_")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(" ");
//   };

//   const roomKey = getRoomKeyFromPath();
//   const roomTitle = getRoomTitle(roomKey);

//   // ✅ For student side, we need receiver_id based on room
//   const getReceiverId = () => {
//     const assignedAdmins = studentDetails?.assigned_admins;
//     if (!assignedAdmins) return null;

//     switch (roomKey) {
//       case "cv_upload":
//       case "sop":
//       case "lor":
//       case "university_specific_sop":
//       case "ug_only":
//       case "final_documents_upload":
//         return assignedAdmins.assigned_content_writer?.id;
//       case "shortlisting_of_universities":
//         return assignedAdmins.assigned_to?.id;
//       case "university_application_process":
//         return assignedAdmins.assigned_application_manager?.id;
//       case "visa_process":
//         return assignedAdmins.assigned_visa_manager?.id;
//       default:
//         return assignedAdmins.assigned_to?.id;
//     }
//   };

//   const receiverId = getReceiverId();
//   const roomname = roomKey && receiverId ? `${roomKey}_${userId}` : null;

//   const connectionState = getConnectionState(roomKey, userId);

//   // ✅ Check if university tagging is enabled for this room
//   const enableUniversityTagging = roomKey === "university_application_process";

//   // Generate unique message ID
//   const generateMessageId = (msg) => {
//     if (msg.message_id) return `mid_${msg.message_id}`;
//     if (msg.client_message_id) return `cid_${msg.client_message_id}`;
//     return `temp_${msg.sender_id}_${msg.date_sent}`;
//   };

//   // ✅ Fetch universities for tagging
//   const fetchUniversities = async (query) => {
//     try {
//       const response = await getPostFinalizedData();

//       if (!response.data || !Array.isArray(response.data.universities)) {
//         setMentionSuggestions([]);
//         return;
//       }

//       const universities = response.data.universities;

//       if (universities.length > 0) {
//         const filteredUniversities = universities.filter(
//           (uni) =>
//             uni.university_name &&
//             uni.university_name.toLowerCase().includes(query.toLowerCase())
//         );

//         setMentionSuggestions(filteredUniversities);
//       } else {
//         setMentionSuggestions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching universities:", error);
//       setMentionSuggestions([]);
//     }
//   };

//   // ✅ Handle comment change with university mention detection
//   const handleCommentChange = (e) => {
//     const value = e.target.value;
//     setComment(value);

//     if (!enableUniversityTagging) return;

//     const cursorPosition = e.target.selectionStart;
//     setMentionPosition(cursorPosition);

//     const words = value.substring(0, cursorPosition).split(/\s+/);
//     const lastWord = words[words.length - 1];

//     if (lastWord.startsWith("@")) {
//       const searchQuery = lastWord.substring(1);
//       if (searchQuery.length > 0) {
//         fetchUniversities(searchQuery);
//       } else {
//         setMentionSuggestions([]);
//       }
//     } else {
//       setMentionSuggestions([]);
//     }
//   };

//   // ✅ Handle university selection
//   const handleSelectUniversity = (university) => {
//     const words = comment.substring(0, mentionPosition).split(/\s+/);
//     words[words.length - 1] = `@${university.university_name} `;
//     const updatedComment = words.join(" ") + comment.substring(mentionPosition);

//     setComment(updatedComment);
//     setMentionSuggestions([]);

//     // Refocus textarea
//     if (textareaRef.current) {
//       textareaRef.current.focus();
//     }
//   };

//   // ✅ Render comment with mentions highlighted
//   const renderCommentWithMentions = (text) => {
//     if (!text) return "";

//     const mentionRegex = /(@[a-zA-Z0-9\s]+)/g;
//     return text.split(mentionRegex).map((part, index) => {
//       if (part && part.startsWith("@")) {
//         return (
//           <span
//             key={index}
//             className="bg-blue-100 text-blue-700 rounded px-1 font-semibold"
//           >
//             {part}
//           </span>
//         );
//       }
//       return part;
//     });
//   };

//   const isUserNearTop = () => {
//     const el = messagesContainerRef.current;
//     if (!el) return false;
//     return el.scrollTop < 100;
//   };

//   // ✅ File handling functions
//   const handleFileChange = (e) => {
//     const selectedFiles = Array.from(e.target.files || []);
//     setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
//   };

//   const handleRemoveFile = (indexToRemove) => {
//     setFiles((prevFiles) =>
//       prevFiles.filter((_, index) => index !== indexToRemove)
//     );
//   };

//   const getFileIcon = (fileName) => {
//     if (!fileName) return "📁";

//     try {
//       const ext = fileName.split(".").pop().toLowerCase();
//       if (["jpg", "jpeg", "png", "gif"].includes(ext))
//         return <IconPhoto size={20} />;
//       if (["pdf"].includes(ext))
//         return <img src={pdfImageUrl} alt="PDF Icon" width="24" height="24" />;
//       if (["doc", "docx"].includes(ext))
//         return (
//           <img src={docxImageUrl} alt="DOCX Icon" width="24" height="24" />
//         );
//       return "📁";
//     } catch (error) {
//       console.error("Error getting file icon:", error);
//       return "📁";
//     }
//   };

//   // ✅ Format file size
//   const formatFileSize = (bytes) => {
//     if (!bytes || isNaN(bytes)) return "0 B";
//     if (bytes < 1024) return bytes + " B";
//     if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
//     return (bytes / (1024 * 1024)).toFixed(1) + " MB";
//   };

//   const extractFileName = (fileName) => {
//     if (!fileName) return "file";

//     try {
//       const decodedName = decodeURIComponent(fileName);
//       return decodedName.replace(/^[a-f0-9]{32,}_/, "");
//     } catch (error) {
//       console.error("Error extracting filename:", error);
//       return fileName;
//     }
//   };

//   const normalizeFilePath = (path) => {
//     if (!path) return null;

//     try {
//       let normalizedPath = path.replace(/\\/g, "/").replace(/%5C/g, "/");

//       if (
//         normalizedPath.startsWith("http://") ||
//         normalizedPath.startsWith("https://")
//       ) {
//         return normalizedPath;
//       }

//       if (normalizedPath.startsWith("/media")) {
//         return `${process.env.REACT_APP_BASE_URL}${normalizedPath}`;
//       }

//       if (!normalizedPath.startsWith("/")) {
//         return `${process.env.REACT_APP_BASE_URL}/media/${normalizedPath}`;
//       }

//       return normalizedPath;
//     } catch (error) {
//       console.error("Error normalizing path:", error);
//       return path;
//     }
//   };

//   const forceDownload = (url, filename) => {
//     if (!url) {
//       console.error("No URL provided for download");
//       return;
//     }

//     try {
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = filename || "download";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error("Error forcing download:", error);
//       window.open(url, "_blank");
//     }
//   };

//   // ✅ Handle incoming messages with proper replacement
//   const handleIncoming = (msg) => {
//     if (!msg) return;

//     msg.message = msg.message || msg.content || "";
//     msg.sender_id = msg.sender_id || msg.sender;

//     const sortMessages = (msgs) =>
//       [...msgs].sort(
//         (a, b) =>
//           new Date(a.date_sent).getTime() - new Date(b.date_sent).getTime()
//       );

//     // -----------------------------------------------------
//     // ✅ CASE 1: SERVER CONFIRMATION (message_id + client_message_id)
//     // -----------------------------------------------------
//     if (msg.message_id && msg.client_message_id) {
//       const uid = `mid_${msg.message_id}`;

//       if (processedIds.current.has(uid)) {
//         console.log("⚠️ Duplicate server message:", uid);
//         return;
//       }
//       processedIds.current.add(uid);

//       // Remove optimistic pending entry
//       setPending((p) => {
//         const updated = { ...p };
//         delete updated[msg.client_message_id];
//         return updated;
//       });

//       // Replace optimistic → real message
//       setMessages((prev) => {
//         const withoutOptimistic = prev.filter(
//           (m) => m.client_message_id !== msg.client_message_id
//         );

//         const finalList = [
//           ...withoutOptimistic,
//           { ...msg, isDelivered: true, isPending: false },
//         ];

//         return sortMessages(finalList);
//       });

//       return;
//     }

//     // -----------------------------------------------------
//     // ✅ CASE 2: NORMAL MESSAGE FROM OTHER USER
//     // -----------------------------------------------------
//     const uid = msg.message_id
//       ? `mid_${msg.message_id}`
//       : `temp_${msg.sender_id}_${msg.date_sent}`;

//     if (processedIds.current.has(uid)) {
//       console.log("⚠️ Duplicate message skipped:", uid);
//       return;
//     }

//     processedIds.current.add(uid);

//     setMessages((prev) => {
//       const newList = [...prev, { ...msg, isDelivered: true }];
//       return sortMessages(newList);
//     });
//   };

//   const handleMessageFailed = (data) => {
//     console.error("❌ Message failed:", data);

//     const { client_message_id, error } = data;

//     // Remove from pending
//     setPending((p) => {
//       const updated = { ...p };
//       delete updated[client_message_id];
//       return updated;
//     });

//     // Mark message as failed
//     setMessages((prev) => {
//       const updated = prev.map((m) =>
//         m.client_message_id === client_message_id
//           ? { ...m, isPending: false, isFailed: true, error }
//           : m
//       );

//       return sortMessages(updated);
//     });

//     alert(`Failed to send message: ${error}`);
//   };

//   // ✅ Connect WebSocket
//   useEffect(() => {
//     if (!roomKey || !userId) {
//       console.error("❌ Missing roomKey or userId", { roomKey, userId });
//       return;
//     }

//     if (!receiverId) {
//       console.error("❌ Missing receiverId - cannot establish connection");
//       return;
//     }

//     console.log("🔌 Connecting to room:", {
//       roomKey,
//       userId,
//       receiverId,
//       roomname,
//       pathname: location.pathname,
//     });

//     setMessages([]);
//     setPending({});
//     processedIds.current.clear();
//     setLoadingHistory(true);

//     createConnection(roomKey, userId, {
//       userId: userId,
//       receiverId: receiverId,
//       onMessage: handleIncoming,
//       onMessageFailed: handleMessageFailed,
//       onHistoryComplete: (data) => {
//         console.log("✅ History loaded:", data?.count || 0, "messages");
//         setLoadingHistory(false);
//       },
//       onError: (err) => {
//         console.error("❌ WebSocket error:", err);
//         setLoadingHistory(false);
//       },
//       onDisconnect: (reason) => {
//         console.log("🔴 Disconnected:", reason);
//       },
//     });

//     return () => {
//       console.log("🚪 Cleaning up room:", roomname);
//       closeConnection(roomKey, userId);
//     };
//   }, [location.pathname, roomKey, userId, receiverId]);

//   // ✅ Auto scroll to top for new messages
//   useEffect(() => {
//     if (!messagesContainerRef.current) return;

//     const lastMsg = messages[0];
//     const shouldScroll = isUserNearTop() || lastMsg?.sender_id === userId;

//     if (shouldScroll) {
//       setTimeout(() => {
//         topRef.current?.scrollIntoView({ behavior: "smooth" });
//       }, 100);
//     }
//   }, [messages]);

//   // ✅ Upload files to backend
//   const uploadFiles = async (files) => {
//     if (files.length === 0) return [];

//     setUploadingFiles(true);

//     try {
//       const formData = new FormData();

//       files.forEach((file) => {
//         formData.append("files", file);
//       });

//       // Add metadata
//       formData.append("roomname", roomname);
//       formData.append("sender_id", userId);

//       const response = await fetch(
//         `${process.env.REACT_APP_BASE_URL}/chat_app/api/upload-files/`,
//         {
//           method: "POST",
//           body: formData,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("File upload failed");
//       }

//       const data = await response.json();

//       console.log("✅ Files uploaded:", data);

//       // Return array of uploaded file URLs
//       return data.file_urls || [];
//     } catch (error) {
//       console.error("❌ File upload error:", error);
//       alert("Failed to upload files. Please try again.");
//       return [];
//     } finally {
//       setUploadingFiles(false);
//     }
//   };

//   // ✅ Send message with files
//   const handleSend = async () => {
//     if (!comment.trim() && files.length === 0) {
//       console.log("⚠️ Empty message and no files");
//       return;
//     }

//     if (!roomKey || !userId) {
//       console.error("❌ Cannot send - missing room or user");
//       return;
//     }

//     if (!receiverId) {
//       alert("Receiver not found. Please contact support.");
//       return;
//     }

//     if (connectionState.status !== "connected") {
//       console.error("❌ Cannot send - not connected");
//       alert("Not connected. Please wait...");
//       return;
//     }

//     const cid = genId();

//     // ✅ Upload files first if any
//     let fileUrls = [];
//     if (files.length > 0) {
//       fileUrls = await uploadFiles(files);

//       if (fileUrls.length === 0 && files.length > 0) {
//         // Upload failed
//         return;
//       }
//     }

//     console.log("📤 Preparing to send message:", {
//       client_message_id: cid,
//       roomname,
//       message: comment.substring(0, 50) + "...",
//       files: fileUrls.length,
//     });

//     // ✅ Create optimistic message
//     const optimistic = {
//       client_message_id: cid,
//       message: comment,
//       sender_id: userId,
//       sender_username: username,
//       first_name: firstName,
//       last_name: lastName,
//       sender_role: userRole,
//       sender_profile_pic: userPic,
//       file_urls: fileUrls,
//       date_sent: new Date().toISOString(),
//       isPending: true,
//       receiver_id: receiverId,
//     };

//     // ✅ Add optimistic message to UI
//     setMessages((prev) => {
//       const newList = [...prev, optimistic];
//       return sortMessages(newList);
//     });

//     setPending((p) => ({ ...p, [cid]: optimistic }));

//     // ✅ Send via WebSocket
//     sendMessage(roomKey, userId, {
//       message: comment,
//       sender_id: userId,
//       receiver_id: receiverId,
//       client_message_id: cid,
//       file_urls: fileUrls,
//     });

//     // ✅ Clear input and files
//     setComment("");
//     setFiles([]);

//     console.log("✅ Message sent, awaiting server confirmation");
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSend();
//     }
//   };

//   const groupByDate = (msgs) => {
//     const grouped = {};
//     msgs.forEach((m) => {
//       const date = new Date(m.date_sent).toDateString();
//       if (!grouped[date]) grouped[date] = [];
//       grouped[date].push(m);
//     });
//     return grouped;
//   };

//   const groupMessagesByDate = (messages) => {
//     if (!messages || messages.length === 0) return {};

//     // Group by date
//     const grouped = messages.reduce((groups, message) => {
//       const dateKey = new Date(message.date_sent).toLocaleDateString("en-US", {
//         weekday: "short",
//         month: "short",
//         day: "numeric",
//       });

//       if (!groups[dateKey]) groups[dateKey] = [];
//       groups[dateKey].push(message);

//       return groups;
//     }, {});

//     // Sort date groups newest first AND messages newest first
//     const sortedEntries = Object.entries(grouped).sort((a, b) => {
//       const dateA = new Date(a[1][0].date_sent);
//       const dateB = new Date(b[1][0].date_sent);
//       return dateB - dateA; // recent date first
//     });

//     const finalGroups = {};

//     sortedEntries.forEach(([key, msgs]) => {
//       // 🔥 This is the important line
//       finalGroups[key] = msgs.sort(
//         (a, b) =>
//           new Date(b.date_sent).getTime() - new Date(a.date_sent).getTime()
//       );
//     });

//     return finalGroups;
//   };

//   // ✅ Avatar generation functions
//   const getInitialsAvatar = (firstName, lastName, username) => {
//     try {
//       if (
//         firstName &&
//         firstName.length > 0 &&
//         lastName &&
//         lastName.length > 0
//       ) {
//         return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
//       }

//       if (firstName && firstName.length > 0) {
//         return `${firstName.charAt(0)}${
//           firstName.length > 1 ? firstName.charAt(1) : ""
//         }`.toUpperCase();
//       }

//       if (lastName && lastName.length > 0) {
//         return `${lastName.charAt(0)}${
//           lastName.length > 1 ? lastName.charAt(1) : ""
//         }`.toUpperCase();
//       }

//       if (username && username.length > 0) {
//         const parts = username.split(/[\s_.-]/);
//         if (parts.length > 1) {
//           return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(
//             0
//           )}`.toUpperCase();
//         }
//         if (username.length > 1) {
//           return `${username.charAt(0)}${username.charAt(
//             username.length - 1
//           )}`.toUpperCase();
//         }
//         if (username.length === 1) {
//           return `${username.charAt(0)}S`.toUpperCase();
//         }
//       }

//       return "ST";
//     } catch (error) {
//       console.error("Error generating initials:", error);
//       return "ST";
//     }
//   };

//   const getAvatarColor = (initials) => {
//     try {
//       if (!initials || initials.length === 0) return "#757575";

//       const hash = initials
//         .split("")
//         .reduce((acc, char) => acc + char.charCodeAt(0), 0);

//       const colors = [
//         "#1E88E5",
//         "#43A047",
//         "#E53935",
//         "#FB8C00",
//         "#8E24AA",
//         "#00ACC1",
//         "#3949AB",
//         "#00897B",
//         "#7CB342",
//         "#C0CA33",
//         "#FFB300",
//         "#F4511E",
//         "#6D4C41",
//         "#757575",
//         "#546E7A",
//       ];

//       return colors[hash % colors.length];
//     } catch (error) {
//       console.error("Error getting avatar color:", error);
//       return "#757575";
//     }
//   };

//   const generateAvatar = (
//     firstName,
//     lastName,
//     username,
//     profilePic,
//     userId,
//     size = "small"
//   ) => {
//     try {
//       const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

//       if (profilePic) {
//         const normalizedProfilePic = normalizeFilePath(profilePic);

//         if (normalizedProfilePic) {
//           return (
//             <div
//               className={`${sizeClass} rounded-full overflow-hidden border-2 border-white shadow-md flex-shrink-0`}
//             >
//               <img
//                 src={normalizedProfilePic}
//                 alt={`${firstName || username || "User"}'s avatar`}
//                 className="w-full h-full object-cover"
//                 onError={(e) => {
//                   const initials = getInitialsAvatar(
//                     firstName,
//                     lastName,
//                     username
//                   );
//                   e.target.style.display = "none";
//                   e.target.parentNode.innerHTML = `
//                     <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
//                       style="background-color: ${getAvatarColor(initials)}">
//                       ${initials}
//                     </div>
//                   `;
//                 }}
//               />
//             </div>
//           );
//         }
//       }

//       const initials = getInitialsAvatar(firstName, lastName, username);
//       const backgroundColor = getAvatarColor(initials);

//       return (
//         <div
//           className={`flex items-center justify-center rounded-full ${sizeClass} text-white font-medium flex-shrink-0`}
//           style={{ backgroundColor }}
//         >
//           {initials}
//         </div>
//       );
//     } catch (error) {
//       console.error("Error generating avatar:", error);
//       return (
//         <div className="flex items-center justify-center rounded-full w-10 h-10 text-white font-medium flex-shrink-0 bg-gray-500">
//           ST
//         </div>
//       );
//     }
//   };

//   const grouped = groupMessagesByDate(messages);

//   // ✅ Show error if location is not available
//   if (!location) {
//     return (
//       <div className="flex items-center justify-center h-full bg-gray-50 p-8 rounded-lg shadow-md w-full">
//         <div className="text-center">
//           <p className="text-red-600 font-medium mb-2 text-lg">
//             ⚠️ Navigation Error
//           </p>
//           <p className="text-sm text-gray-600">
//             Please ensure this component is used within a React Router context.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* ✅ LOADING OVERLAY */}
//       {uploadingFiles && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center">
//           <div className="bg-white rounded-lg p-8 shadow-2xl flex flex-col items-center max-w-md">
//             <svg
//               className="animate-spin h-16 w-16 text-purple-600 mb-4"
//               viewBox="0 0 24 24"
//             >
//               <circle
//                 className="opacity-25"
//                 cx="12"
//                 cy="12"
//                 r="10"
//                 stroke="currentColor"
//                 strokeWidth="4"
//                 fill="none"
//               />
//               <path
//                 className="opacity-75"
//                 fill="currentColor"
//                 d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//               />
//             </svg>
//             <p className="text-xl font-semibold text-gray-800 mb-2">
//               Sending message...
//             </p>
//             <p className="text-sm text-gray-500 mt-4 text-center">
//               Please wait, do not close or refresh the page
//             </p>
//           </div>
//         </div>
//       )}

//       <div className="flex flex-col h-full bg-gray-50 rounded-lg shadow-md overflow-hidden w-full select-text">
//         {/* ✅ HEADER */}
//         <div className="flex justify-between items-center bg-purple-700 text-white p-4">
//           <h3 className="text-lg font-semibold">{roomTitle}</h3>
//           <div className="flex items-center gap-2">
//             {connectionState.status === "connected" && (
//               <span className="flex items-center gap-1 text-xs">
//                 <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
//                 Connected
//               </span>
//             )}
//             {connectionState.status === "connecting" && (
//               <span className="flex items-center gap-1 text-xs text-yellow-300">
//                 <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
//                 Connecting...
//               </span>
//             )}
//             {connectionState.status === "disconnected" && (
//               <span className="flex items-center gap-1 text-xs text-red-300">
//                 <div className="w-2 h-2 bg-red-400 rounded-full"></div>
//                 Reconnecting...
//               </span>
//             )}
//           </div>
//         </div>

//         {/* ✅ Show error if receiver not found */}
//         {!receiverId && roomKey && (
//           <div className="flex items-center justify-center p-8 bg-yellow-50 border-b border-yellow-200">
//             <div className="text-center">
//               <p className="text-yellow-800 font-medium mb-2">
//                 ⚠️ No assigned admin found for this section
//               </p>
//               <p className="text-sm text-yellow-600">
//                 Please contact support to assign an admin for "{roomTitle}"
//               </p>
//             </div>
//           </div>
//         )}

//         {/* ✅ INPUT AREA (TOP) */}
//         <div className="bg-white p-4 border-b border-gray-200 shadow-sm">
//           <div className="flex items-start">
//             {generateAvatar(
//               firstName,
//               lastName,
//               username,
//               studentDetails?.profile_picture_url || userPic,
//               userId
//             )}
//             <div className="flex-grow mx-3 relative">
//               <textarea
//                 ref={textareaRef}
//                 value={comment}
//                 onChange={handleCommentChange}
//                 onKeyDown={handleKeyDown}
//                 placeholder={
//                   enableUniversityTagging
//                     ? "Write a message... (Use @ to mention universities)"
//                     : "Write a message..."
//                 }
//                 className="w-full border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 rounded-lg resize-none"
//                 rows="2"
//               ></textarea>

//               {/* ✅ UNIVERSITY MENTION SUGGESTIONS */}
//               {enableUniversityTagging && mentionSuggestions.length > 0 && (
//                 <ul className="absolute bg-white border border-gray-300 shadow-lg list-none p-0 mt-1 max-h-48 overflow-y-auto w-full rounded-md z-10">
//                   {mentionSuggestions.map((university) => (
//                     <li
//                       key={university.id}
//                       onClick={() => handleSelectUniversity(university)}
//                       className="p-2 cursor-pointer hover:bg-gray-100"
//                     >
//                       {university.university_name}
//                     </li>
//                   ))}
//                 </ul>
//               )}

//               {/* ✅ FILE PREVIEW */}
//               {files.length > 0 && (
//                 <div className="mt-2 space-y-2">
//                   {files.map((file, index) => (
//                     <div
//                       key={index}
//                       className="p-2 bg-gray-100 rounded-md flex items-center"
//                     >
//                       <span className="mr-2">{getFileIcon(file.name)}</span>
//                       <span className="text-sm font-medium truncate flex-1">
//                         {file.name}
//                       </span>
//                       <button
//                         onClick={() => handleRemoveFile(index)}
//                         className="ml-2 text-gray-500 hover:text-red-500 flex-shrink-0"
//                       >
//                         ✕
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* ✅ ACTION BUTTONS */}
//             <div className="flex space-x-2">
//               <label className="cursor-pointer p-2 bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 flex items-center justify-center w-10 h-10 transition-colors">
//                 <IconPaperclip size={20} />
//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   onChange={handleFileChange}
//                   className="hidden"
//                   multiple
//                 />
//               </label>
//               <button
//                 onClick={handleSend}
//                 disabled={
//                   (!comment.trim() && files.length === 0) ||
//                   connectionState.status !== "connected" ||
//                   uploadingFiles
//                 }
//                 className="bg-purple-600 text-white p-2 rounded-full hover:bg-purple-700 transition-colors flex items-center justify-center w-10 h-10 disabled:opacity-50"
//               >
//                 <IconSend size={20} />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* ✅ MESSAGES CONTAINER */}
//         <div
//           ref={messagesContainerRef}
//           className="flex-1 overflow-y-auto p-4 flex flex-col space-y-4"
//           style={{ maxHeight: "calc(100vh - 300px)" }}
//         >
//           <div ref={topRef} />
//           {loadingHistory ? (
//             <div className="flex items-center justify-center h-full">
//               <p className="text-gray-500 italic">Loading messages...</p>
//             </div>
//           ) : Object.keys(grouped).length === 0 ? (
//             <div className="flex items-center justify-center h-full">
//               <p className="text-gray-400 italic">
//                 No messages yet. Start the conversation!
//               </p>
//             </div>
//           ) : (
//             Object.entries(grouped).map(
//               ([dateKey, messagesGroup], groupIndex) => (
//                 <div key={`group-${groupIndex}`}>
//                   {/* ✅ DATE DIVIDER */}
//                   <div className="flex justify-center my-3">
//                     <div className="px-4 py-1 rounded-full bg-gray-200 text-xs text-gray-600">
//                       {dateKey}
//                     </div>
//                   </div>

//                   {/* ✅ MESSAGES */}
//                   {messagesGroup.map((comment, index) => {
//                     const isCurrentUser = comment.sender_id === userId;
//                     const isAdmin =
//                       comment.sender_role === "admin" || comment.is_admin;
//                     const isConsecutive =
//                       index > 0 &&
//                       comment.sender_id === messagesGroup[index - 1].sender_id;

//                     const isPending = comment.isPending;
//                     const isFailed = comment.isFailed;

//                     const linkifyMessage = (message, isCurrentUser) => {
//                       if (!message) return "";

//                       const urlRegex =
//                         /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

//                       return message.replace(urlRegex, (match) => {
//                         const url = match.startsWith("http")
//                           ? match
//                           : `https://${match}`;
//                         const linkColorClass = isCurrentUser
//                           ? "text-white underline cursor-pointer"
//                           : "text-blue-700 underline hover:text-blue-900 cursor-pointer";

//                         return `<a href="${url}" class="${linkColorClass} break-words" target="_blank" rel="noopener noreferrer">${match}</a>`;
//                       });
//                     };

//                     const createMarkup = (msg) => {
//                       return { __html: linkifyMessage(msg, isCurrentUser) };
//                     };

//                     return (
//                       <div
//                         key={`comment-${index}-${generateMessageId(comment)}`}
//                       >
//                         <div
//                           className={`flex items-start gap-2 ${
//                             isCurrentUser ? "flex-row-reverse" : "flex-row"
//                           }`}
//                         >
//                           {/* ✅ AVATAR */}
//                           {!isConsecutive ? (
//                             <div className="flex-shrink-0">
//                               {isCurrentUser
//                                 ? generateAvatar(
//                                     firstName,
//                                     lastName,
//                                     username,
//                                     userPic,
//                                     userId
//                                   )
//                                 : generateAvatar(
//                                     comment.first_name,
//                                     comment.last_name,
//                                     comment.sender_username || "User",
//                                     comment.sender_profile_pic,
//                                     comment.sender_id
//                                   )}
//                             </div>
//                           ) : (
//                             <div className="w-10"></div>
//                           )}

//                           {/* ✅ MESSAGE CONTENT */}
//                           <div className="flex flex-col max-w-xs md:max-w-md">
//                             {!isConsecutive && (
//                               <span
//                                 className={`text-xs font-medium mb-1 flex items-center gap-1 ${
//                                   isCurrentUser
//                                     ? "text-right justify-end"
//                                     : "text-left"
//                                 }`}
//                               >
//                                 {isCurrentUser
//                                   ? "You"
//                                   : comment.sender_username || "User"}
//                                 {isPending && (
//                                   <span className="text-gray-400 italic ml-1">
//                                     Sending...
//                                   </span>
//                                 )}
//                               </span>
//                             )}

//                             <div
//                               className={`rounded-lg p-2 ${
//                                 isCurrentUser
//                                   ? "bg-purple-600 text-white rounded-tr-none"
//                                   : isAdmin
//                                   ? "bg-green-100 text-green-900 rounded-tl-none"
//                                   : "bg-gray-200 text-gray-800 rounded-tl-none"
//                               } ${isPending ? "opacity-60" : ""}`}
//                             >
//                               {/* ✅ MESSAGE TEXT */}
//                               {comment.message && comment.message.trim() && (
//                                 <div
//                                   className="prose max-w-none break-words overflow-x-auto p-1"
//                                   dangerouslySetInnerHTML={createMarkup(
//                                     comment.message
//                                   )}
//                                 ></div>
//                               )}

//                               {/* ✅ FILE ATTACHMENTS */}
//                               {((comment.file_urls &&
//                                 comment.file_urls.length > 0 &&
//                                 comment.file_urls[0] !== "pending") ||
//                                 (comment.file_attachments &&
//                                   comment.file_attachments.length > 0)) && (
//                                 <div className="mt-2 space-y-2">
//                                   {(
//                                     comment.file_attachments ||
//                                     comment.file_urls.map((url, i) => ({
//                                       url,
//                                       name: null,
//                                     }))
//                                   ).map((attachment, fileIndex) => {
//                                     const fileUrl =
//                                       attachment.url || attachment;
//                                     const rawFileName = fileUrl
//                                       .split("/")
//                                       .pop();
//                                     const cleanedFileName =
//                                       attachment.name ||
//                                       extractFileName(rawFileName);
//                                     const parts = fileUrl.split("/").slice(3);
//                                     let path = "/" + parts.join("/");
//                                     path = path.replace(/\/backend/g, "");

//                                     const isImage =
//                                       /\.(jpe?g|png|gif|bmp|webp)$/i.test(
//                                         cleanedFileName
//                                       );

//                                     return (
//                                       <div key={fileIndex}>
//                                         {isImage ? (
//                                           <a
//                                             href={`${process.env.REACT_APP_BASE_URL}${path}`}
//                                             target="_blank"
//                                             rel="noopener noreferrer"
//                                             className="block mt-2"
//                                           >
//                                             <img
//                                               src={`${process.env.REACT_APP_BASE_URL}${path}`}
//                                               alt={cleanedFileName}
//                                               className="max-h-48 rounded border border-gray-300 object-contain bg-white"
//                                               onError={(e) => {
//                                                 console.error(
//                                                   "Image load error:",
//                                                   e.target.src
//                                                 );
//                                                 e.target.style.display = "none";
//                                               }}
//                                             />
//                                           </a>
//                                         ) : (
//                                           <button
//                                             onClick={() =>
//                                               forceDownload(
//                                                 `${process.env.REACT_APP_BASE_URL}${path}`,
//                                                 cleanedFileName
//                                               )
//                                             }
//                                             className={`flex items-center space-x-2 p-2 rounded ${
//                                               isCurrentUser
//                                                 ? "bg-purple-700 text-purple-100"
//                                                 : "bg-white text-gray-800"
//                                             } shadow-sm hover:opacity-80 transition-opacity`}
//                                           >
//                                             <span className="flex-shrink-0">
//                                               {getFileIcon(cleanedFileName)}
//                                             </span>
//                                             <span className="text-sm truncate">
//                                               {cleanedFileName}
//                                             </span>
//                                           </button>
//                                         )}
//                                       </div>
//                                     );
//                                   })}
//                                 </div>
//                               )}

//                               {/* ✅ FAILED STATUS */}
//                               {isFailed && (
//                                 <div className="mt-2 text-xs text-red-300 italic">
//                                   ❌ Failed to send
//                                 </div>
//                               )}
//                             </div>

//                             {/* ✅ TIMESTAMP */}
//                             <span
//                               className={`text-xs text-gray-500 mt-1 ${
//                                 isCurrentUser ? "text-right" : "text-left"
//                               }`}
//                             >
//                               {new Date(comment.date_sent).toLocaleTimeString(
//                                 [],
//                                 {
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                 }
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               )
//             )
//           )}
//         </div>
//       </div>
//     </>
//   );
// }
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  IconSend,
  IconPaperclip,
  IconX,
  IconPhoto,
  IconFile,
  IconFileTypePdf,
  IconFileTypeDocx,
  IconFileTypeXls,
  IconFileTypePpt,
  IconFileTypeTxt,
  IconFileTypeCsv,
} from "@tabler/icons-react";

import { useWebSocket } from "../../state/reducers/WebSocketProvider";
import { getPostFinalizedData } from "../../services/admin.services";

import DomPurify from "dompurify";

const genId = () => `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

export default function Comments() {
  const location = useLocation();
  const fileInputRef = useRef(null);
  const topRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const processedIds = useRef(new Set());
  const textareaRef = useRef(null);

  const user = useSelector((s) => s.user);
  const studentDetails = useSelector((s) => s.user.userDetails);

  const userId = user?.user_id;
  const username = user?.username;
  const firstName = user?.first_name;
  const lastName = user?.last_name;
  const userRole = user?.role || "student";
  const userPic = user?.profile?.profile_picture_url;

  const { createConnection, closeConnection, sendMessage, getConnectionState } =
    useWebSocket();

  const [messages, setMessages] = useState([]);
  const [pending, setPending] = useState({});
  const [comment, setComment] = useState("");
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [files, setFiles] = useState([]);

  // ✅ University tagging states
  const [mentionPosition, setMentionPosition] = useState(null);
  const [mentionSuggestions, setMentionSuggestions] = useState([]);

  // ✅ Helper function to safely get first/last name
  const getFirstName = () => {
    if (firstName) return firstName;
    if (username && typeof username === "string") {
      const parts = username.split(" ");
      return parts[0] || "S";
    }
    return "S";
  };
  const sortMessages = (msgs) =>
    [...msgs].sort(
      (a, b) =>
        new Date(a.date_sent).getTime() - new Date(b.date_sent).getTime()
    );

  const getLastName = () => {
    if (lastName) return lastName;
    if (username && typeof username === "string") {
      const parts = username.split(" ");
      return parts[1] || "T";
    }
    return "T";
  };

  // ✅ Extract room key from URL path
  const getRoomKeyFromPath = () => {
    if (!location || !location.pathname) {
      console.warn("⚠️ Location or pathname is undefined");
      return null;
    }

    const pathParts = location.pathname.split("/").filter(Boolean); // Remove empty strings
    const lastPart = pathParts[pathParts.length - 1];

    console.log("📍 Path parts:", pathParts, "Room key:", lastPart);

    // Return the last part of the path (e.g., "visa_process" from "/student/visa_process")
    return lastPart || null;
  };

  // ✅ Convert room key to display title
  const getRoomTitle = (roomKey) => {
    if (!roomKey) return "Comments";

    // Convert snake_case to Title Case
    return roomKey
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Decode HTML entities so pasted/escaped HTML (e.g. &lt;a href=...&gt;) renders as links
  const decodeHtmlEntities = (str) => {
    if (!str || typeof str !== "string") return str;
    return str
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")
      .replace(/&amp;/g, "&");
  };

  const linkifyHtml = (htmlString, isCurrentUser) => {
    if (!htmlString) return "";
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      
      const textNodes = [];
      const walk = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          let parent = node.parentNode;
          let insideLink = false;
          while (parent) {
            if (parent.tagName === "A") {
              insideLink = true;
              break;
            }
            parent = parent.parentNode;
          }
          if (!insideLink && node.nodeValue.trim()) {
            textNodes.push(node);
          }
        } else {
          for (let i = 0; i < node.childNodes.length; i++) {
            walk(node.childNodes[i]);
          }
        }
      };
      
      walk(doc.body);
      
      const urlRegex = /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;
      
      for (const node of textNodes) {
        const text = node.nodeValue;
        if (urlRegex.test(text)) {
          urlRegex.lastIndex = 0;
          const parent = node.parentNode;
          const span = doc.createElement("span");
          
          let lastIndex = 0;
          let match;
          
          while ((match = urlRegex.exec(text)) !== null) {
            const matchText = match[0];
            const matchIndex = match.index;
            
            if (matchIndex > lastIndex) {
              span.appendChild(doc.createTextNode(text.substring(lastIndex, matchIndex)));
            }
            
            const url = matchText.startsWith("http") ? matchText : `https://${matchText}`;
            const a = doc.createElement("a");
            a.href = url;
            a.target = "_blank";
            a.rel = "noopener noreferrer";
            a.textContent = matchText;
            
            const linkColorClass = isCurrentUser
              ? "text-blue-900 underline font-semibold cursor-pointer hover:text-blue-800 transition-colors"
              : "text-blue-600 underline font-semibold hover:text-blue-800 cursor-pointer transition-colors";
              
            a.className = `${linkColorClass} break-words`;
            span.appendChild(a);
            
            lastIndex = urlRegex.lastIndex;
          }
          
          if (lastIndex < text.length) {
            span.appendChild(doc.createTextNode(text.substring(lastIndex)));
          }
          
          parent.replaceChild(span, node);
        }
      }
      
      return doc.body.innerHTML;
    } catch (e) {
      console.error("Error linkifying HTML:", e);
      return htmlString;
    }
  };

  const containsHtml = (str) => /<[a-z][\s\S]*>/i.test(str);

  const prepareMessageHtml = (message, isCurrentUser) => {
    if (!message) return "";
    const decoded = decodeHtmlEntities(message);
    const htmlWithLinks = linkifyHtml(decoded, isCurrentUser);
    
    // Add support for newlines in plain text
    const processedHtml = containsHtml(decoded) ? htmlWithLinks : htmlWithLinks.replace(/\n/g, "<br/>");
    
    return DomPurify.sanitize(processedHtml, {
      ALLOWED_TAGS: ["a", "b", "i", "u", "strong", "em", "br", "p", "ul", "ol", "li", "span"],
      ALLOWED_ATTR: ["href", "target", "rel", "class"],
    });
  };

  const roomKey = getRoomKeyFromPath();
  const roomTitle = getRoomTitle(roomKey);

  // ✅ For student side, we need receiver_id based on room
  const getReceiverId = () => {
    const assignedAdmins = studentDetails?.assigned_admins;
    if (!assignedAdmins) return null;

    switch (roomKey) {
      case "cv_upload":
      case "sop":
      case "lor":
      case "university_specific_sop":
      case "ug_only":
      case "final_documents_upload":
        return assignedAdmins.assigned_content_writer?.id;
      case "shortlisting_of_universities":
        return assignedAdmins.assigned_to?.id;
      case "university_application_process":
        return assignedAdmins.assigned_application_manager?.id;
      case "visa_process":
        return assignedAdmins.assigned_visa_manager?.id;
      default:
        return assignedAdmins.assigned_to?.id;
    }
  };

  const receiverId = getReceiverId();
  const roomname = roomKey && receiverId ? `${roomKey}_${userId}` : null;

  const connectionState = getConnectionState(roomKey, userId);

  // ✅ Check if university tagging is enabled for this room
  const enableUniversityTagging = roomKey === "university_application_process";

  // Load draft when roomname or userId changes
  useEffect(() => {
    if (userId && roomname) {
      const savedDraft = localStorage.getItem(`chat_draft_${userId}_${roomname}`) || "";
      setComment(savedDraft);
    } else {
      setComment("");
    }
  }, [roomname, userId]);

  // Generate unique message ID
  const generateMessageId = (msg) => {
    if (msg.message_id) return `mid_${msg.message_id}`;
    if (msg.client_message_id) return `cid_${msg.client_message_id}`;
    return `temp_${msg.sender_id}_${msg.date_sent}`;
  };

  // ✅ Fetch universities for tagging
  const fetchUniversities = async (query) => {
    try {
      const response = await getPostFinalizedData();

      if (!response.data || !Array.isArray(response.data.universities)) {
        setMentionSuggestions([]);
        return;
      }

      const universities = response.data.universities;

      if (universities.length > 0) {
        const filteredUniversities = universities.filter(
          (uni) =>
            uni.university_name &&
            uni.university_name.toLowerCase().includes(query.toLowerCase())
        );

        setMentionSuggestions(filteredUniversities);
      } else {
        setMentionSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching universities:", error);
      setMentionSuggestions([]);
    }
  };

  // ✅ Handle comment change with university mention detection
  const handleCommentChange = (e) => {
    const value = e.target.value;
    setComment(value);
    if (userId && roomname) {
      localStorage.setItem(`chat_draft_${userId}_${roomname}`, value);
    }

    if (!enableUniversityTagging) return;

    const cursorPosition = e.target.selectionStart;
    setMentionPosition(cursorPosition);

    const words = value.substring(0, cursorPosition).split(/\s+/);
    const lastWord = words[words.length - 1];

    if (lastWord.startsWith("@")) {
      const searchQuery = lastWord.substring(1);
      if (searchQuery.length > 0) {
        fetchUniversities(searchQuery);
      } else {
        setMentionSuggestions([]);
      }
    } else {
      setMentionSuggestions([]);
    }
  };

  // ✅ Handle university selection
  const handleSelectUniversity = (university) => {
    const words = comment.substring(0, mentionPosition).split(/\s+/);
    words[words.length - 1] = `@${university.university_name} `;
    const updatedComment = words.join(" ") + comment.substring(mentionPosition);

    setComment(updatedComment);
    if (userId && roomname) {
      localStorage.setItem(`chat_draft_${userId}_${roomname}`, updatedComment);
    }
    setMentionSuggestions([]);

    // Refocus textarea
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };

  // ✅ Render comment with mentions highlighted
  const renderCommentWithMentions = (text) => {
    if (!text) return "";

    const mentionRegex = /(@[a-zA-Z0-9\s]+)/g;
    return text.split(mentionRegex).map((part, index) => {
      if (part && part.startsWith("@")) {
        return (
          <span
            key={index}
            className="bg-blue-100 text-blue-700 rounded px-1 font-semibold"
          >
            {part}
          </span>
        );
      }
      return part;
    });
  };

  const isUserNearTop = () => {
    const el = messagesContainerRef.current;
    if (!el) return false;
    return el.scrollTop < 100;
  };

  // ✅ File handling functions
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };

  // const getFileIcon = (fileName) => {
  //   if (!fileName) return "📁";

  //   try {
  //     const ext = fileName.split(".").pop().toLowerCase();
  //     if (["jpg", "jpeg", "png", "gif"].includes(ext))
  //       return <IconPhoto size={20} />;
  //     if (["pdf"].includes(ext))
  //       return <img src={pdfImageUrl} alt="PDF Icon" width="24" height="24" />;
  //     if (["doc", "docx"].includes(ext))
  //       return (
  //         <img src={docxImageUrl} alt="DOCX Icon" width="24" height="24" />
  //       );
  //     return "📁";
  //   } catch (error) {
  //     console.error("Error getting file icon:", error);
  //     return "📁";
  //   }
  // };

  // ✅ Format file size

  const getFileIcon = (fileName) => {
    const ext = (fileName?.split(".").pop() || "").toLowerCase();

    // Images
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
      return <IconPhoto size={20} className="flex-shrink-0" />;
    }

    // PDF
    if (ext === "pdf") {
      return (
        <IconFileTypePdf size={20} className="flex-shrink-0 text-red-600" />
      );
    }

    // Word
    if (["doc", "docx"].includes(ext)) {
      return (
        <IconFileTypeDocx size={20} className="flex-shrink-0 text-blue-600" />
      );
    }

    // Excel
    if (["xls", "xlsx"].includes(ext)) {
      return (
        <IconFileTypeXls size={20} className="flex-shrink-0 text-green-600" />
      );
    }

    // CSV
    if (ext === "csv") {
      return (
        <IconFileTypeCsv size={20} className="flex-shrink-0 text-green-700" />
      );
    }

    // PPT
    if (["ppt", "pptx"].includes(ext)) {
      return (
        <IconFileTypePpt size={20} className="flex-shrink-0 text-orange-600" />
      );
    }

    // TXT
    if (ext === "txt") {
      return (
        <IconFileTypeTxt size={20} className="flex-shrink-0 text-gray-600" />
      );
    }

    // Default
    return <IconFile size={20} className="flex-shrink-0 text-gray-600" />;
  };

  const formatFileSize = (bytes) => {
    if (!bytes || isNaN(bytes)) return "0 B";
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  };

  const extractFileName = (fileName) => {
    if (!fileName) return "file";

    try {
      const decodedName = decodeURIComponent(fileName);
      return decodedName.replace(/^[a-f0-9]{32,}_/, "");
    } catch (error) {
      console.error("Error extracting filename:", error);
      return fileName;
    }
  };

  const normalizeFilePath = (path) => {
    if (!path) return null;

    try {
      let normalizedPath = path.replace(/\\/g, "/").replace(/%5C/g, "/");

      if (
        normalizedPath.startsWith("http://") ||
        normalizedPath.startsWith("https://")
      ) {
        return normalizedPath;
      }

      if (normalizedPath.startsWith("/media")) {
        return `${process.env.REACT_APP_BASE_URL}${normalizedPath}`;
      }

      if (!normalizedPath.startsWith("/")) {
        return `${process.env.REACT_APP_BASE_URL}/media/${normalizedPath}`;
      }

      return normalizedPath;
    } catch (error) {
      console.error("Error normalizing path:", error);
      return path;
    }
  };

  const forceDownload = (url, filename) => {
    if (!url) {
      console.error("No URL provided for download");
      return;
    }

    try {
      const link = document.createElement("a");
      link.href = url;
      link.download = filename || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error forcing download:", error);
      window.open(url, "_blank");
    }
  };

  // ✅ Handle incoming messages with proper replacement
  const handleIncoming = (msg) => {
    if (!msg) return;

    msg.message = msg.message || msg.content || "";
    msg.sender_id = msg.sender_id || msg.sender;

    const sortMessages = (msgs) =>
      [...msgs].sort(
        (a, b) =>
          new Date(a.date_sent).getTime() - new Date(b.date_sent).getTime()
      );

    // -----------------------------------------------------
    // ✅ CASE 1: SERVER CONFIRMATION (message_id + client_message_id)
    // -----------------------------------------------------
    if (msg.message_id && msg.client_message_id) {
      const uid = `mid_${msg.message_id}`;

      if (processedIds.current.has(uid)) {
        console.log("⚠️ Duplicate server message:", uid);
        return;
      }
      processedIds.current.add(uid);

      // Remove optimistic pending entry
      setPending((p) => {
        const updated = { ...p };
        delete updated[msg.client_message_id];
        return updated;
      });

      // Replace optimistic → real message
      setMessages((prev) => {
        const withoutOptimistic = prev.filter(
          (m) => m.client_message_id !== msg.client_message_id
        );

        const finalList = [
          ...withoutOptimistic,
          { ...msg, isDelivered: true, isPending: false },
        ];

        return sortMessages(finalList);
      });

      return;
    }

    // -----------------------------------------------------
    // ✅ CASE 2: NORMAL MESSAGE FROM OTHER USER
    // -----------------------------------------------------
    const uid = msg.message_id
      ? `mid_${msg.message_id}`
      : `temp_${msg.sender_id}_${msg.date_sent}`;

    if (processedIds.current.has(uid)) {
      console.log("⚠️ Duplicate message skipped:", uid);
      return;
    }

    processedIds.current.add(uid);

    setMessages((prev) => {
      const newList = [...prev, { ...msg, isDelivered: true }];
      return sortMessages(newList);
    });
  };

  const handleMessageFailed = (data) => {
    console.error("❌ Message failed:", data);

    const { client_message_id, error } = data;

    // Remove from pending
    setPending((p) => {
      const updated = { ...p };
      delete updated[client_message_id];
      return updated;
    });

    // Mark message as failed
    setMessages((prev) => {
      const updated = prev.map((m) =>
        m.client_message_id === client_message_id
          ? { ...m, isPending: false, isFailed: true, error }
          : m
      );

      return sortMessages(updated);
    });

    alert(`Failed to send message: ${error}`);
  };

  // ✅ Connect WebSocket
  useEffect(() => {
    if (!roomKey || !userId) {
      console.error("❌ Missing roomKey or userId", { roomKey, userId });
      return;
    }

    if (!receiverId) {
      console.error("❌ Missing receiverId - cannot establish connection");
      return;
    }

    console.log("🔌 Connecting to room:", {
      roomKey,
      userId,
      receiverId,
      roomname,
      pathname: location.pathname,
    });

    setMessages([]);
    setPending({});
    processedIds.current.clear();
    setLoadingHistory(true);

    createConnection(roomKey, userId, {
      userId: userId,
      receiverId: receiverId,
      onMessage: handleIncoming,
      onMessageFailed: handleMessageFailed,
      onHistoryComplete: (data) => {
        console.log("✅ History loaded:", data?.count || 0, "messages");
        setLoadingHistory(false);
      },
      onError: (err) => {
        console.error("❌ WebSocket error:", err);
        setLoadingHistory(false);
      },
      onDisconnect: (reason) => {
        console.log("🔴 Disconnected:", reason);
      },
    });

    return () => {
      console.log("🚪 Cleaning up room:", roomname);
      closeConnection(roomKey, userId);
    };
  }, [location.pathname, roomKey, userId, receiverId]);

  // ✅ Auto scroll to top for new messages
  useEffect(() => {
    if (!messagesContainerRef.current) return;

    const lastMsg = messages[0];
    const shouldScroll = isUserNearTop() || lastMsg?.sender_id === userId;

    if (shouldScroll) {
      setTimeout(() => {
        topRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [messages]);

  // ✅ Upload files to backend
  const uploadFiles = async (files) => {
    if (files.length === 0) return [];

    setUploadingFiles(true);

    try {
      const formData = new FormData();

      files.forEach((file) => {
        formData.append("files", file);
      });

      // Add metadata
      formData.append("roomname", roomname);
      formData.append("sender_id", userId);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/chat_app/api/upload-files/`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("File upload failed");
      }

      const data = await response.json();

      console.log("✅ Files uploaded:", data);

      // Return array of uploaded file URLs
      return data.file_urls || [];
    } catch (error) {
      console.error("❌ File upload error:", error);
      alert("Failed to upload files. Please try again.");
      return [];
    } finally {
      setUploadingFiles(false);
    }
  };

  // ✅ Send message with files
  const handleSend = async () => {
    if (!comment.trim() && files.length === 0) {
      console.log("⚠️ Empty message and no files");
      return;
    }

    if (!roomKey || !userId) {
      console.error("❌ Cannot send - missing room or user");
      return;
    }

    if (!receiverId) {
      alert("Receiver not found. Please contact support.");
      return;
    }

    if (connectionState.status !== "connected") {
      console.error("❌ Cannot send - not connected");
      alert("Not connected. Please wait...");
      return;
    }

    const cid = genId();

    // ✅ Upload files first if any
    let fileUrls = [];
    if (files.length > 0) {
      fileUrls = await uploadFiles(files);

      if (fileUrls.length === 0 && files.length > 0) {
        // Upload failed
        return;
      }
    }

    console.log("📤 Preparing to send message:", {
      client_message_id: cid,
      roomname,
      message: comment.substring(0, 50) + "...",
      files: fileUrls.length,
    });

    // ✅ Create optimistic message
    const optimistic = {
      client_message_id: cid,
      message: comment,
      sender_id: userId,
      sender_username: username,
      first_name: firstName,
      last_name: lastName,
      sender_role: userRole,
      sender_profile_pic: userPic,
      file_urls: fileUrls,
      date_sent: new Date().toISOString(),
      isPending: true,
      receiver_id: receiverId,
    };

    // ✅ Add optimistic message to UI
    setMessages((prev) => {
      const newList = [...prev, optimistic];
      return sortMessages(newList);
    });

    setPending((p) => ({ ...p, [cid]: optimistic }));

    // ✅ Send via WebSocket
    sendMessage(roomKey, userId, {
      message: comment,
      sender_id: userId,
      receiver_id: receiverId,
      client_message_id: cid,
      file_urls: fileUrls,
    });

    // ✅ Clear input and files
    setComment("");
    if (userId && roomname) {
      localStorage.removeItem(`chat_draft_${userId}_${roomname}`);
    }
    setFiles([]);

    console.log("✅ Message sent, awaiting server confirmation");
  };

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter" && !e.shiftKey) {
  //     e.preventDefault();
  //     handleSend();
  //   }
  // };

  const groupByDate = (msgs) => {
    const grouped = {};
    msgs.forEach((m) => {
      const date = new Date(m.date_sent).toDateString();
      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(m);
    });
    return grouped;
  };

  const groupMessagesByDate = (messages) => {
    if (!messages || messages.length === 0) return {};

    // Group by date
    const grouped = messages.reduce((groups, message) => {
      const dateKey = new Date(message.date_sent).toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
      });

      if (!groups[dateKey]) groups[dateKey] = [];
      groups[dateKey].push(message);

      return groups;
    }, {});

    // Sort date groups newest first AND messages newest first
    const sortedEntries = Object.entries(grouped).sort((a, b) => {
      const dateA = new Date(a[1][0].date_sent);
      const dateB = new Date(b[1][0].date_sent);
      return dateB - dateA; // recent date first
    });

    const finalGroups = {};

    sortedEntries.forEach(([key, msgs]) => {
      // 🔥 This is the important line
      finalGroups[key] = msgs.sort(
        (a, b) =>
          new Date(b.date_sent).getTime() - new Date(a.date_sent).getTime()
      );
    });

    return finalGroups;
  };

  // ✅ Avatar generation functions
  const getInitialsAvatar = (firstName, lastName, username) => {
    try {
      if (
        firstName &&
        firstName.length > 0 &&
        lastName &&
        lastName.length > 0
      ) {
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
      }

      if (firstName && firstName.length > 0) {
        return `${firstName.charAt(0)}${
          firstName.length > 1 ? firstName.charAt(1) : ""
        }`.toUpperCase();
      }

      if (lastName && lastName.length > 0) {
        return `${lastName.charAt(0)}${
          lastName.length > 1 ? lastName.charAt(1) : ""
        }`.toUpperCase();
      }

      if (username && username.length > 0) {
        const parts = username.split(/[\s_.-]/);
        if (parts.length > 1) {
          return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(
            0
          )}`.toUpperCase();
        }
        if (username.length > 1) {
          return `${username.charAt(0)}${username.charAt(
            username.length - 1
          )}`.toUpperCase();
        }
        if (username.length === 1) {
          return `${username.charAt(0)}S`.toUpperCase();
        }
      }

      return "ST";
    } catch (error) {
      console.error("Error generating initials:", error);
      return "ST";
    }
  };

  const getAvatarColor = (initials) => {
    try {
      if (!initials || initials.length === 0) return "#757575";

      const hash = initials
        .split("")
        .reduce((acc, char) => acc + char.charCodeAt(0), 0);

      const colors = [
        "#1E88E5",
        "#43A047",
        "#E53935",
        "#FB8C00",
        "#8E24AA",
        "#00ACC1",
        "#3949AB",
        "#00897B",
        "#7CB342",
        "#C0CA33",
        "#FFB300",
        "#F4511E",
        "#6D4C41",
        "#757575",
        "#546E7A",
      ];

      return colors[hash % colors.length];
    } catch (error) {
      console.error("Error getting avatar color:", error);
      return "#757575";
    }
  };

  const generateAvatar = (
    firstName,
    lastName,
    username,
    profilePic,
    userId,
    size = "small"
  ) => {
    try {
      const sizeClass = size === "small" ? "w-10 h-10" : "w-12 h-12";

      if (profilePic) {
        const normalizedProfilePic = normalizeFilePath(profilePic);

        if (normalizedProfilePic) {
          return (
            <div
              className={`${sizeClass} rounded-full overflow-hidden border-2 border-white shadow-md flex-shrink-0`}
            >
              <img
                src={normalizedProfilePic}
                alt={`${firstName || username || "User"}'s avatar`}
                className="w-full h-full object-cover"
                onError={(e) => {
                  const initials = getInitialsAvatar(
                    firstName,
                    lastName,
                    username
                  );
                  e.target.style.display = "none";
                  e.target.parentNode.innerHTML = `
                    <div class="flex items-center justify-center rounded-full ${sizeClass} text-white font-medium"
                      style="background-color: ${getAvatarColor(initials)}">
                      ${initials}
                    </div>
                  `;
                }}
              />
            </div>
          );
        }
      }

      const initials = getInitialsAvatar(firstName, lastName, username);
      const backgroundColor = getAvatarColor(initials);

      return (
        <div
          className={`flex items-center justify-center rounded-full ${sizeClass} text-white font-medium flex-shrink-0`}
          style={{ backgroundColor }}
        >
          {initials}
        </div>
      );
    } catch (error) {
      console.error("Error generating avatar:", error);
      return (
        <div className="flex items-center justify-center rounded-full w-10 h-10 text-white font-medium flex-shrink-0 bg-gray-500">
          ST
        </div>
      );
    }
  };

  const grouped = groupMessagesByDate(messages);

  // ✅ Show error if location is not available
  if (!location) {
    return (
      <div className="flex items-center justify-center h-full bg-gray-50 p-8 rounded-lg shadow-md w-full">
        <div className="text-center">
          <p className="text-red-600 font-medium mb-2 text-lg">
            ⚠️ Navigation Error
          </p>
          <p className="text-sm text-gray-600">
            Please ensure this component is used within a React Router context.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* ✅ LOADING OVERLAY */}
      {uploadingFiles && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center">
          <div className="bg-white rounded-lg p-8 shadow-2xl flex flex-col items-center max-w-md">
            <svg
              className="animate-spin h-16 w-16 text-purple-600 mb-4"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
            <p className="text-xl font-semibold text-gray-800 mb-2">
              Sending message...
            </p>
            <p className="text-sm text-gray-500 mt-4 text-center">
              Please wait, do not close or refresh the page
            </p>
          </div>
        </div>
      )}

      <div className="flex flex-col h-full bg-gray-50 rounded-lg shadow-md overflow-hidden w-full select-text">
        {/* ✅ HEADER */}
        <div className="flex justify-between items-center bg-purple-700 text-white p-4">
          <h3 className="text-lg font-semibold">{roomTitle}</h3>
          <div className="flex items-center gap-2">
            {connectionState.status === "connected" && (
              <span className="flex items-center gap-1 text-xs">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                Connected
              </span>
            )}
            {connectionState.status === "connecting" && (
              <span className="flex items-center gap-1 text-xs text-yellow-300">
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
                Connecting...
              </span>
            )}
            {connectionState.status === "disconnected" && (
              <span className="flex items-center gap-1 text-xs text-red-300">
                <div className="w-2 h-2 bg-red-400 rounded-full"></div>
                Reconnecting...
              </span>
            )}
          </div>
        </div>

        {/* ✅ Show error if receiver not found */}
        {!receiverId && roomKey && (
          <div className="flex items-center justify-center p-8 bg-yellow-50 border-b border-yellow-200">
            <div className="text-center">
              <p className="text-yellow-800 font-medium mb-2">
                ⚠️ No assigned admin found for this section
              </p>
              <p className="text-sm text-yellow-600">
                Please contact support to assign an admin for "{roomTitle}"
              </p>
            </div>
          </div>
        )}

        {/* ✅ INPUT AREA (TOP) */}
        <div className="bg-white p-4 border-b border-gray-200 shadow-sm">
          <div className="flex items-start">
            {generateAvatar(
              firstName,
              lastName,
              username,
              studentDetails?.profile_picture_url || userPic,
              userId
            )}
            <div className="flex-grow mx-3 relative">
              <textarea
                ref={textareaRef}
                value={comment}
                onChange={handleCommentChange}
                // onKeyDown={handleKeyDown}
                placeholder={
                  enableUniversityTagging
                    ? "Write a message... (Use @ to mention universities)"
                    : "Write a message..."
                }
                className="w-full border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 rounded-lg resize-none"
                rows="2"
              ></textarea>

              {/* ✅ UNIVERSITY MENTION SUGGESTIONS */}
              {enableUniversityTagging && mentionSuggestions.length > 0 && (
                <ul className="absolute bg-white border border-gray-300 shadow-lg list-none p-0 mt-1 max-h-48 overflow-y-auto w-full rounded-md z-10">
                  {mentionSuggestions.map((university) => (
                    <li
                      key={university.id}
                      onClick={() => handleSelectUniversity(university)}
                      className="p-2 cursor-pointer hover:bg-gray-100"
                    >
                      {university.university_name}
                    </li>
                  ))}
                </ul>
              )}

              {/* ✅ FILE PREVIEW */}
              {files.length > 0 && (
                <div className="mt-2 space-y-2">
                  {files.map((file, index) => (
                    <div
                      key={index}
                      className="p-2 bg-gray-100 rounded-md flex items-center"
                    >
                      <span className="mr-2">{getFileIcon(file.name)}</span>
                      <span className="text-sm font-medium truncate flex-1">
                        {file.name}
                      </span>
                      <button
                        onClick={() => handleRemoveFile(index)}
                        className="ml-2 text-gray-500 hover:text-red-500 flex-shrink-0"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* ✅ ACTION BUTTONS */}
            <div className="flex space-x-2">
              <label className="cursor-pointer p-2 bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 flex items-center justify-center w-10 h-10 transition-colors">
                <IconPaperclip size={20} />
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="hidden"
                  accept="image/*,.pdf,.doc,.docx,.txt,.xls,.xlsx,.csv,.ppt,.pptx"
                  multiple
                />
              </label>
              <button
                onClick={handleSend}
                disabled={
                  (!comment.trim() && files.length === 0) ||
                  connectionState.status !== "connected" ||
                  uploadingFiles
                }
                className="bg-purple-600 text-white p-2 rounded-full hover:bg-purple-700 transition-colors flex items-center justify-center w-10 h-10 disabled:opacity-50"
              >
                <IconSend size={20} />
              </button>
            </div>
          </div>
        </div>

        {/* ✅ MESSAGES CONTAINER */}
        <div
          ref={messagesContainerRef}
          className="flex-1 overflow-y-auto p-4 flex flex-col space-y-4"
          style={{ maxHeight: "calc(100vh - 300px)" }}
        >
          <div ref={topRef} />
          {loadingHistory ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-500 italic">Loading messages...</p>
            </div>
          ) : Object.keys(grouped).length === 0 ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-400 italic">
                No messages yet. Start the conversation!
              </p>
            </div>
          ) : (
            Object.entries(grouped).map(
              ([dateKey, messagesGroup], groupIndex) => (
                <div key={`group-${groupIndex}`}>
                  {/* ✅ DATE DIVIDER */}
                  <div className="flex justify-center my-3">
                    <div className="px-4 py-1 rounded-full bg-gray-200 text-xs text-gray-600">
                      {dateKey}
                    </div>
                  </div>

                  {/* ✅ MESSAGES */}
                  {messagesGroup.map((comment, index) => {
                    const isCurrentUser = comment.sender_id === userId;
                    const isAdmin =
                      comment.sender_role === "admin" || comment.is_admin;
                    const isConsecutive =
                      index > 0 &&
                      comment.sender_id === messagesGroup[index - 1].sender_id;

                    const isPending = comment.isPending;
                    const isFailed = comment.isFailed;

                    // const linkifyMessage = (message, isCurrentUser) => {
                    //   if (!message) return "";

                    //   const urlRegex =
                    //     /\b((https?:\/\/|www\.)[^\s<]+[^<.,:;"')\]\s])/gi;

                    //   return message.replace(urlRegex, (match) => {
                    //     const url = match.startsWith("http")
                    //       ? match
                    //       : `https://${match}`;

                    //     // 🎨 NEW COLOR SCHEME FOR LINKS
                    //     const linkColorClass = isCurrentUser
                    //       ? "text-blue-900 underline font-semibold cursor-pointer hover:text-blue-800 transition-colors"
                    //       : "text-blue-600 underline font-semibold hover:text-blue-800 cursor-pointer transition-colors";

                    //     return `<a href="${url}" class="${linkColorClass} break-words" target="_blank" rel="noopener noreferrer">${match}</a>`;
                    //   });
                    // };
                    return (
                      <div
                        key={`comment-${index}-${generateMessageId(comment)}`}
                      >
                        <div
                          className={`flex items-start gap-2 ${
                            isCurrentUser ? "flex-row-reverse" : "flex-row"
                          }`}
                        >
                          {/* ✅ AVATAR */}
                          {!isConsecutive ? (
                            <div className="flex-shrink-0">
                              {isCurrentUser
                                ? generateAvatar(
                                    firstName,
                                    lastName,
                                    username,
                                    userPic,
                                    userId
                                  )
                                : generateAvatar(
                                    comment.first_name,
                                    comment.last_name,
                                    comment.sender_username || "User",
                                    comment.sender_profile_pic,
                                    comment.sender_id
                                  )}
                            </div>
                          ) : (
                            <div className="w-10"></div>
                          )}

                          {/* ✅ MESSAGE CONTENT */}
                          <div className="flex flex-col max-w-xs md:max-w-md">
                            {!isConsecutive && (
                              <span
                                className={`text-xs font-medium mb-1 flex items-center gap-1 ${
                                  isCurrentUser
                                    ? "text-right justify-end"
                                    : "text-left"
                                }`}
                              >
                                {isCurrentUser
                                  ? "You"
                                  : comment.sender_username || "User"}
                                {isPending && (
                                  <span className="text-gray-400 italic ml-1">
                                    Sending...
                                  </span>
                                )}
                              </span>
                            )}

                            {/* 🎨 NEW BUBBLE COLORS WITH BETTER CONTRAST */}
                            <div
                              className={`rounded-lg p-3 shadow-sm ${
                                isCurrentUser
                                  ? "bg-indigo-100 text-gray-900 rounded-tr-none border border-indigo-200"
                                  : isAdmin
                                  ? "bg-emerald-50 text-gray-900 rounded-tl-none border border-emerald-200"
                                  : "bg-white text-gray-900 rounded-tl-none border border-gray-200"
                              } ${isPending ? "opacity-60" : ""}`}
                            >
                              {/* ✅ MESSAGE TEXT */}
                              {comment.message && comment.message.trim() && (
                                <div className="ql-snow">
                                  <div
                                    className="prose prose-sm max-w-none break-words overflow-x-auto leading-relaxed ql-editor"
                                    dangerouslySetInnerHTML={{
                                      __html: prepareMessageHtml(
                                        comment.message,
                                        isCurrentUser
                                      ),
                                    }}
                                  />
                                </div>
                              )}

                              {/* ✅ FILE ATTACHMENTS */}
                              {((comment.file_urls &&
                                comment.file_urls.length > 0 &&
                                comment.file_urls[0] !== "pending") ||
                                (comment.file_attachments &&
                                  comment.file_attachments.length > 0)) && (
                                <div className="mt-2 space-y-2">
                                  {(
                                    comment.file_attachments ||
                                    comment.file_urls.map((url, i) => ({
                                      url,
                                      name: null,
                                    }))
                                  ).map((attachment, fileIndex) => {
                                    const fileUrl =
                                      attachment.url || attachment;
                                    const rawFileName = fileUrl
                                      .split("/")
                                      .pop();
                                    const cleanedFileName =
                                      attachment.name ||
                                      extractFileName(rawFileName);
                                    const parts = fileUrl.split("/").slice(3);
                                    let path = "/" + parts.join("/");
                                    path = path.replace(/\/backend/g, "");

                                    const isImage =
                                      /\.(jpe?g|png|gif|bmp|webp)$/i.test(
                                        cleanedFileName
                                      );

                                    return (
                                      <div key={fileIndex}>
                                        {isImage ? (
                                          <a
                                            href={`${process.env.REACT_APP_BASE_URL}${path}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="block mt-2"
                                          >
                                            <img
                                              src={`${process.env.REACT_APP_BASE_URL}${path}`}
                                              alt={cleanedFileName}
                                              className="max-h-48 rounded border border-gray-300 object-contain bg-white shadow-sm"
                                              onError={(e) => {
                                                console.error(
                                                  "Image load error:",
                                                  e.target.src
                                                );
                                                e.target.style.display = "none";
                                              }}
                                            />
                                          </a>
                                        ) : (
                                          <button
                                            onClick={() =>
                                              forceDownload(
                                                `${process.env.REACT_APP_BASE_URL}${path}`,
                                                cleanedFileName
                                              )
                                            }
                                            className={`flex items-center space-x-2 p-2 rounded w-full ${
                                              isCurrentUser
                                                ? "bg-indigo-200 text-indigo-900 hover:bg-indigo-300"
                                                : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                                            } shadow-sm transition-colors`}
                                          >
                                            <span className="flex-shrink-0">
                                              {getFileIcon(cleanedFileName)}
                                            </span>
                                            <span className="text-sm truncate font-medium">
                                              {cleanedFileName}
                                            </span>
                                          </button>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}

                              {/* ✅ FAILED STATUS */}
                              {isFailed && (
                                <div className="mt-2 text-xs text-red-600 font-medium italic">
                                  ❌ Failed to send
                                </div>
                              )}
                            </div>

                            {/* ✅ TIMESTAMP */}
                            <span
                              className={`text-xs text-gray-500 mt-1 ${
                                isCurrentUser ? "text-right" : "text-left"
                              }`}
                            >
                              {new Date(comment.date_sent).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            )
          )}
        </div>
      </div>
    </>
  );
}
